<template>
  <v-dialog v-model="dialog" persistent width="1200px">
    <v-card>
      <v-card-title class="headline mb-0">
        <v-icon>edit</v-icon> Modificar permiso
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form
        @submit.prevent="save"
        v-model="valid"
        ref="form"
        lazy-validation
        class="p-0"
      >
        <v-card-text class="px-4 py-0">
          <v-container class="p-0" grid-list-md style="min-width: 100%">
            <v-layout row wrap>
              <v-flex xs12>
                <h4 class="blue--text">
                  Tipo de permiso : <b>{{ permiso.tipo_permiso }}</b>
                </h4>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex
                xs12
                md6
                v-if="id_permi == 44 && permiso.id_tipo_permiso != 0"
              >
                <v-select
                  class="text-field-reducido-border"
                  @change="obtenerSubpermiso(permiso.id_tipo_permiso)"
                  :items="tipo_subpermisos"
                  item-value="id"
                  item-text="descripcion"
                  name="id_tipo_subpermiso"
                  label="Condición o estado crítico de salud"
                  v-model="permiso.id_tipo_subpermiso"
                  autofocus
                  maxlength="200"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                ></v-select>
              </v-flex>
              <v-flex xs12 v-if="id_permi == 5">
                <v-select
                  class="text-field-reducido-border"
                  :items="capacitacion_censista"
                  :item-value="
                    val => {
                      return parseInt(val.id);
                    }
                  "
                  item-text="valor"
                  name="capacitacion_censista"
                  label="Seleccionar tipo de participación"
                  v-model="permiso.id_parametro_permiso"
                  autofocus
                  :rules="$validate(['required'])"
                  required
                  outline
                  :clearable="
                    permiso.id_permiso ==
                      (primer_permiso_censo ? primer_permiso_censo.id : -1)
                  "
                  :readonly="
                    !!primer_permiso_censo &&
                      permiso.id_permiso != primer_permiso_censo.id
                  "
                  :disabled="
                    !!primer_permiso_censo &&
                      permiso.id_permiso != primer_permiso_censo.id
                  "
                ></v-select>
              </v-flex>
              <v-flex xs12 v-if="permiso.id_parametro_permiso && id_permi == 5">
                <v-alert
                  v-if="
                    !!primer_permiso_censo &&
                      permiso.id_permiso != primer_permiso_censo.id
                  "
                  class="text-xs-justify"
                  color="blue"
                  icon="done"
                  value="true"
                  outline
                >
                  {{
                    `Ya tiene creado el primer permiso de este tipo (Nro de papeleta:
                    ${primer_permiso_censo.numero}
                    ${primer_permiso_censo.fecha_desde}-
                    ${primer_permiso_censo.fecha_hasta}(
                    ${
                      primer_permiso_censo.dias
                    })dias), en el cual seleccionó la opción: ${
                      capacitacion_censista.filter(
                        ele =>
                          ele.id == primer_permiso_censo.id_parametro_permiso
                      )[0].valor
                    }`
                  }}
                </v-alert>
                <v-alert
                  v-if="permiso.id_parametro_permiso == 135"
                  class="text-xs-justify"
                  color="indigo"
                  icon="warning"
                  value="true"
                  outline
                >
                  Se le otorga una (1) jornada laboral al personal que
                  habiendose capacitado fuera de horario laboral no fué
                  convocado por el INE para el día del empadronamiento D.S. 5097
                </v-alert>
                <v-alert
                  v-if="permiso.id_parametro_permiso == 136"
                  class="text-xs-justify"
                  color="indigo"
                  icon="warning"
                  value="true"
                  outline
                >
                  Se le otorga dos (2) jornadas laborales al personal que
                  participo efectivamente el día del empadronamiento como
                  agentes censales enel Censo de Población y Vivienda 2024 D.S.
                  5097
                </v-alert>
              </v-flex>
              <!-- Campo motivo permiso sin goce de haberes p18 -->
              <v-flex
                xs12
                md6
                v-if="id_permi == 18 && permiso.id_tipo_permiso != 0"
              >
                <v-select
                  class="text-field-reducido-border"
                  @change="obtenerSubpermiso(permiso.id_tipo_permiso)"
                  :items="tipo_subpermisos"
                  item-value="descripcion"
                  item-text="descripcion"
                  name="tipo_subpermiso"
                  label="Causal de acuerdo al ART. 15 RM 1111:"
                  v-model="permiso.motivo"
                  autofocus
                  maxlength="200"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                ></v-select>
              </v-flex>

              <v-flex xs12 md4 v-if="id_permi == 90">
                <v-autocomplete
                  class="text-field-reducido-border"
                  :items="tipos_baja"
                  item-value="descripcion"
                  item-text="descripcion"
                  v-model="permi_motivo"
                  label="Tipo de baja"
                  maxlength="50"
                  @change="activarBandera()"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <v-flex
                xs12
                v-if="id_permi == 87 || id_permi == 96 || id_permi == 103 || id_permi == 105"
              >
                <v-textarea
                  class="text-field-reducido-border"
                  label="Motivo"
                  v-model="permi_motivo"
                  rows="1"
                  auto-grow
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                ></v-textarea>
              </v-flex>

              <v-flex xs12 md4 v-if="id_permi == 101">
                <v-textarea
                  class="text-field-reducido-border"
                  label="Motivo"
                  type="text"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  v-model="permi_motivo"
                />
              </v-flex>

              <v-flex xs12 md4 v-if="id_permi == 87 || id_permi == 103">
                <v-text-field
                  class="text-field-reducido-border"
                  v-model="permi_lugar"
                  label="Lugar de comisión "
                  maxlength="50"
                  :rules="$validate(['required'])"
                  outline
                  clearable
                />
              </v-flex>
              <v-flex xs12 md4 v-if="id_permi == 12">
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="permiso.fecha_nac_muerte"
                  label="Fecha de matrimonio"
                  @input="obtenerFechaSalidaYEntrada()"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <v-flex xs12 md4 v-if="id_permi == 61">
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="permiso.fecha_nac_muerte"
                  label="Fecha de nacimiento"
                  @input="obtenerFechaSalidaYEntrada()"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <v-flex xs12 md4 v-if="id_permi == 61">
                <v-text-field
                  class="text-field-reducido-border"
                  type="time"
                  v-model="permiso.hora_nac_muerte"
                  label="Hora de nacimiento"
                  @input="obtenerFechaSalidaYEntrada()"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <v-flex xs12 md4 v-if="id_permi == 6">
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="permiso.fecha_nac_muerte"
                  label="Fecha de fallecimiento"
                  @input="obtenerFechaSalidaYEntrada()"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <v-flex xs12 md4 v-if="id_permi == 6">
                <v-text-field
                  class="text-field-reducido-border"
                  type="time"
                  v-model="permiso.hora_nac_muerte"
                  label="Hora de fallecimiento"
                  @input="obtenerFechaSalidaYEntrada()"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <v-flex
                xs12
                md6
                v-if="
                  id_permi != 101 &&
                    id_permi != 100 &&
                    id_permi != 99 &&
                    id_permi != 98 &&
                    id_permi != 89 &&
                    id_permi != 94 &&
                    id_permi != 87 &&
                    id_permi != 88 &&
                    id_permi != 96 &&
                    id_permi != 37 &&
                    id_permi != 38 &&
                    id_permi != 39 &&
                    id_permi != 40 &&
                    id_permi != 41 &&
                    id_permi != 42 &&
                    id_permi != 6 &&
                    id_permi != 61 &&
                    id_permi != 12 &&
                    id_permi != 102 &&
                    id_permi != 43
                "
              >
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="permisoDetalle.fecha_desde"
                  label="Fecha salida"
                  :rules="$validate(['required'])"
                  outline
                  clearable
                  @change="calculaDiasHabiles() && desactivarBandera()"
                  @input="obtenerSiguienteFecha()"
                />
              </v-flex>
              <v-flex xs12 md6 v-if="id_permi == 102">
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="permisoDetalle.fecha_desde"
                  label="Fecha"
                  :rules="$validate(['required'])"
                  outline
                  clearable
                  @input="calculaHorarioDiscontinuo()"
                />
              </v-flex>
              <v-flex
                xs12
                md6
                v-if="
                  id_permi == 101 ||
                    id_permi == 100 ||
                    id_permi == 99 ||
                    id_permi == 98 ||
                    id_permi == 89 ||
                    id_permi == 87 ||
                    id_permi == 88 ||
                    id_permi == 96 ||
                    (id_permi >= 37 && id_permi <= 43)
                "
              >
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="permisoDetalle.fecha_desde"
                  label="Fecha"
                  @change="asignarFechaHasta(permisoDetalle.fecha_desde)"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <!--  Omision de registro nde asistencias-->
              <v-flex xs12 md6 v-if="id_permi == 94">
                <v-autocomplete
                  class="text-field-reducido-border"
                  :items="tipos_omision"
                  item-value="id"
                  item-text="valor"
                  v-model="id_tipo_omision"
                  label="Tipo de omisión"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <v-flex xs12 md6 v-if="id_permi == 94">
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="permisoDetalle.fecha_desde"
                  label="Fecha de omisión de marcado"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <v-flex
                xs12
                md6
                v-if="
                  (id_permi == 6 &&
                    permiso.fecha_nac_muerte &&
                    permiso.hora_nac_muerte) ||
                    (id_permi == 61 &&
                      permiso.fecha_nac_muerte &&
                      permiso.hora_nac_muerte) ||
                    (id_permi == 12 && permiso.fecha_nac_muerte)
                "
              >
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="permisoDetalle.fecha_desde"
                  label="Fecha salida"
                  disabled
                  :rules="$validate(['required'])"
                  outline
                  clearable
                />
              </v-flex>
              <v-flex
                xs12
                md6
                v-if="id_permi == 6 || id_permi == 61 || id_permi == 12"
              >
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="permisoDetalle.fecha_hasta"
                  label="Fecha hasta"
                  disabled
                  :rules="$validate(['required'])"
                  outline
                  clearable
                />
              </v-flex>
              <v-flex
                xs12
                md6
                v-if="
                  id_permi == 24 ||
                    id_permi == 18 ||
                    id_permi == 95 ||
                    id_permi == 44 ||
                    id_permi == 103 ||
                    id_permi == 105
                "
              >
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  @change="calculaDiasHabiles()"
                  v-model="permisoDetalle.fecha_hasta"
                  label="Fecha hasta"
                  :rules="$validate(['required'])"
                  outline
                  clearable
                />
              </v-flex>
              <v-flex
                xs12
                md6
                v-if="
                  [90, 5].includes(parseInt(id_permi)) &&
                    permisoDetalle.fecha_desde &&
                    permiso.nro_dias
                "
              >
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="permiso.fecha_retorno"
                  label="Fecha hasta"
                  @change="obtenerSiguienteFecha()"
                  disabled
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>

              <v-flex xs12 md6 v-if="[90, 5].includes(parseInt(id_permi))">
                <v-text-field
                  class="text-field-reducido-border"
                  :value="val => parseInt(val)"
                  name="dias_incapacidad"
                  :label="
                    id_permi == 90
                      ? 'Días de incapacidad'
                      : id_permi == 5
                      ? 'Dias a solicitar'
                      : ''
                  "
                  v-model="permiso.nro_dias"
                  type="number"
                  @change="obtenerSiguienteFecha()"
                  @input="obtenerSiguienteFecha()"
                  autofocus
                  :rules="[v => v > 0 || `Introduzca un valor mayor a 0`]"
                  maxlength="500"
                  required
                  outline
                  clearable
                ></v-text-field>
              </v-flex>

              <v-flex xs12 v-if="id_permi == 18">
                <p>
                  <strong>Total Días:</strong>
                  {{ this.dias_habiles }}
                </p>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-text-field
                  v-if="
                    id_permi != 101 &&
                      id_permi != 100 &&
                      id_permi != 99 &&
                      id_permi != 98 &&
                      id_permi != 89 &&
                      id_permi != 12 &&
                      id_permi != 61 &&
                      id_permi != 6 &&
                      id_permi != 90 &&
                      id_permi != 14 &&
                      id_permi != 15 &&
                      id_permi != 17 &&
                      id_permi != 16 &&
                      id_permi != 8 &&
                      id_permi != 18 &&
                      id_permi != 24 &&
                      id_permi != 87 &&
                      id_permi != 88 &&
                      id_permi != 94 &&
                      id_permi != 95 &&
                      id_permi != 37 &&
                      id_permi != 38 &&
                      id_permi != 39 &&
                      id_permi != 40 &&
                      id_permi != 41 &&
                      id_permi != 42 &&
                      id_permi != 43 &&
                      id_permi != 102 &&
                      id_permi != 105 &&
                      id_permi != 44 &&
                      id_permi != 5
                  "
                  class="text-field-reducido-border"
                  type="time"
                  label="Hora desde"
                  :rules="$validate(['required'])"
                  outline
                  clearable
                  v-model="permisoDetalle.hora_desde"
                />
                <v-text-field
                  class="text-field-reducido-border"
                  v-if="id_permi == 102"
                  type="time"
                  label="Hora desde"
                  disabled
                  :rules="$validate(['required'])"
                  outline
                  clearable
                  v-model="permisoDetalle.hora_desde"
                />
                <v-text-field
                  class="text-field-reducido-border"
                  md2
                  v-if="id_permi == 8 || id_permi == 87 || id_permi == 88"
                  type="time"
                  label="Hora desde"
                  :rules="$validate(['required'])"
                  outline
                  clearable
                  v-model="permisoDetalle.hora_desde"
                />
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-if="
                    id_permi != 101 &&
                      id_permi != 100 &&
                      id_permi != 99 &&
                      id_permi != 98 &&
                      id_permi != 89 &&
                      id_permi != 12 &&
                      id_permi != 61 &&
                      id_permi != 6 &&
                      id_permi != 90 &&
                      id_permi != 88 &&
                      id_permi != 14 &&
                      id_permi != 15 &&
                      id_permi != 17 &&
                      id_permi != 16 &&
                      id_permi != 8 &&
                      id_permi != 18 &&
                      id_permi != 89 &&
                      id_permi != 24 &&
                      id_permi != 87 &&
                      id_permi != 94 &&
                      id_permi != 95 &&
                      id_permi != 37 &&
                      id_permi != 38 &&
                      id_permi != 39 &&
                      id_permi != 40 &&
                      id_permi != 41 &&
                      id_permi != 42 &&
                      id_permi != 43 &&
                      id_permi != 102 &&
                      id_permi != 105 &&
                      id_permi != 44 &&
                      id_permi != 5
                  "
                  class="text-field-reducido-border"
                  type="time"
                  label="Hora hasta"
                  :rules="$validate(['required'])"
                  outline
                  clearable
                  v-model="permisoDetalle.hora_hasta"
                />
                <v-text-field
                  v-if="id_permi == 102"
                  class="text-field-reducido-border"
                  type="time"
                  label="Hora hasta"
                  disabled
                  :rules="$validate(['required'])"
                  outline
                  clearable
                  v-model="permisoDetalle.hora_hasta"
                />
                <v-text-field
                  v-if="id_permi == 8 || id_permi == 87 || id_permi == 88"
                  class="text-field-reducido-border"
                  type="time"
                  label="Hora hasta"
                  :rules="$validate(['required'])"
                  outline
                  clearable
                  v-model="permisoDetalle.hora_hasta"
                />
              </v-flex>

              <v-flex xs12 md6 v-if="id_permi == 102">
                <v-textarea
                  class="text-field-reducido-border"
                  label="Motivo"
                  type="text"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  auto-grow
                  rows="2"
                  v-model="justificacion"
                />
              </v-flex>
              <v-flex v-if="id_permi >= 37 && id_permi <= 43">
                <v-radio-group v-model="permiso.rango_horario2" row>
                  <v-flex xs6>
                    <v-radio label="Mañana" :value="1"></v-radio>
                  </v-flex>
                  <v-flex xs6>
                    <v-radio label="Tarde" :value="2"></v-radio>
                  </v-flex>
                </v-radio-group>
              </v-flex>
              <v-flex xs12 v-if="id_permi == 96">
                <v-radio-group
                  v-model="radio_data"
                  row
                  :rules="[
                    v => {
                      if (v == null) return 'El campo es obligatorio.';
                      return true;
                    }
                  ]"
                >
                  <v-flex xs6>
                    <v-radio label="Con compensación" :value="1"></v-radio>
                  </v-flex>
                  <v-flex xs6>
                    <v-radio label="Sin compensación" :value="0"></v-radio>
                  </v-flex>
                </v-radio-group>
              </v-flex>
            </v-layout>
            <!-- ARCHIVOS -->
            <!-- Eliminar archivo -->
            <v-layout row wrap>
              <v-flex>
                <v-btn
                  color="red"
                  v-if="
                    id_permi == 12 ||
                      id_permi == 87 ||
                      id_permi == 103 ||
                      id_permi == 95 ||
                      id_permi == 6 ||
                      id_permi == 8 ||
                      id_permi == 61 ||
                      id_permi == 18 ||
                      id_permi == 90 ||
                      id_permi == 5 ||
                      id_permi == 96 ||
                      (id_permi >= 37 && id_permi <= 44)
                  "
                  @click.prevent="eliminarArchivo()"
                  icon
                  title="Eliminar archivo"
                >
                  <v-icon>clear</v-icon>
                </v-btn>
              </v-flex>
              <!-- Label nombre respaldo del archivo -->
              <v-flex>
                <p
                  v-if="
                    (id_permi == 12 ||
                      id_permi == 8 ||
                      id_permi == 61 ||
                      id_permi == 6 ||
                      id_permi == 87 ||
                      id_permi == 95 ||
                      id_permi == 18 ||
                      id_permi == 103 ||
                      id_permi == 90 ||
                      id_permi == 5 ||
                      id_permi == 96 ||
                      (id_permi >= 37 && id_permi <= 44)) &&
                      ruta_a &&
                      bandera_file == false
                  "
                >
                  <strong>Respaldo: </strong> {{ ruta_a }}
                </p>

                <p
                  v-if="
                    (id_permi == 12 ||
                      id_permi == 8 ||
                      id_permi == 61 ||
                      id_permi == 6 ||
                      id_permi == 87 ||
                      id_permi == 95 ||
                      id_permi == 18 ||
                      id_permi == 103 ||
                      id_permi == 90 ||
                      id_permi == 5 ||
                      id_permi == 96 ||
                      (id_permi >= 37 && id_permi <= 44)) &&
                      bandera_file == true
                  "
                >
                  <strong>Respaldo: </strong> Sin documento de Respaldo
                </p>
                <p></p>
              </v-flex>
            </v-layout>
            <!-- Archivos no obligatorios -->
            <v-layout>
              <v-flex xs12 md4 v-if="id_permi == 87 || id_permi == 96">
                <div
                  :class="this.file == '' ? 'archivo_vacio' : 'archivo_cargado'"
                >
                  <v-icon>{{
                    this.file == "" ? "file_upload" : "done"
                  }}</v-icon>
                  <input
                    class="input-file"
                    type="file"
                    @change="handleFileUpload()"
                    ref="file"
                    color="primary"
                    dark
                  />
                  {{
                    this.file == "" && id_permi == 44
                      ? "Adjuntar informe emitido por la URH y respaldos"
                      : this.file == "" && id_permi == 6
                      ? "Adjuntar certificado de defuncion emitido por el registro civil"
                      : this.file == "" && id_permi >= 37 && id_permi <= 43
                      ? "Adjuntar formulario otorgado por el servicio médico (Art. 3 Decreto supremo Nº 3164)"
                      : this.file == "" && id_permi == 12
                      ? "Adjuntar certificado de matrimonio emitido por el registro civil"
                      : this.file == "" && id_permi == 61
                      ? "Adjuntar el certificado de nacimiento emitido por el registro civil"
                      : this.file == "" &&
                        id_permi != 90 &&
                        id_permi != 12 &&
                        id_permi != 61 &&
                        id_permi != 44 &&
                        id_permi != 37 &&
                        id_permi != 38 &&
                        id_permi != 39 &&
                        id_permi != 40 &&
                        id_permi != 41 &&
                        id_permi != 43 &&
                        id_permi != 42
                      ? "Adjuntar respaldo"
                      : this.file.name
                  }}
                </div>
                <p class="red--text body-1" v-if="errors.denied">
                  *Formato no admitido por el sistema
                </p>
              </v-flex>
            </v-layout>
            <!-- Archivos obligatorios -->
            <v-layout>
              <v-flex
                md12
                v-if="
                  id_permi == 8 ||
                    id_permi == 12 ||
                    id_permi == 6 ||
                    id_permi == 61 ||
                    id_permi == 18 ||
                    id_permi == 90 ||
                    id_permi == 5 ||
                    id_permi == 95 ||
                    id_permi == 103 ||
                    (id_permi >= 37 && id_permi <= 44)
                "
              >
                <div
                  :class="this.file == '' ? 'archivo_vacio' : 'archivo_cargado'"
                >
                  <v-icon>{{
                    this.file == "" ? "file_upload" : "done"
                  }}</v-icon>
                  <input
                    class="input-file"
                    type="file"
                    @change="handleFileUpload2()"
                    ref="file"
                    accept="application/pdf"
                    :rules="$validate(['required'])"
                    required
                  />
                  {{
                    this.file == "" && id_permi == 90
                      ? "Adjuntar baja médica emitida por el ente gestor de salud"
                      : this.file == "" &&
                        id_permi == 5 &&
                        permiso.id_parametro_permiso == 135
                      ? "Adjuntar certificado que acredite la capacitación"
                      : this.file == "" &&
                        id_permi == 5 &&
                        permiso.id_parametro_permiso == 136
                      ? "Adjuntar certificado que acredite la participación activa al CENSO"
                      : this.file == "" && id_permi == 44
                      ? "Adjuntar informe emitido por la URH y respaldos"
                      : this.file == "" && id_permi == 6
                      ? "Adjuntar certificado de defuncion emitido por el registro civil"
                      : this.file == "" && id_permi >= 37 && id_permi <= 43
                      ? "Adjuntar formulario otorgado por el servicio médico (Art. 3 Decreto supremo Nº 3164)"
                      : this.file == "" && id_permi == 12
                      ? "Adjuntar certificado de matrimonio emitido por el registro civil"
                      : this.file == "" && id_permi == 61
                      ? "Adjuntar el certificado de nacimiento emitido por el registro civil"
                      : this.file == "" && id_permi == 8
                      ? "ADJUNTAR JUSTIFICATIVO"
                      : this.file == "" &&
                        id_permi != 90 &&
                        id_permi != 12 &&
                        id_permi != 61 &&
                        id_permi != 44 &&
                        id_permi != 37 &&
                        id_permi != 38 &&
                        id_permi != 39 &&
                        id_permi != 40 &&
                        id_permi != 41 &&
                        id_permi != 43 &&
                        id_permi != 42
                      ? "Adjuntar respaldo"
                      : this.file.name
                  }}
                </div>
                <p class="red--text body-1" v-if="errors2.file">
                  *Debe seleccionar un archivo
                </p>

                <p class="red--text body-1" v-if="errors2.denied">
                  *Formato no admitido por el sistema
                </p>
              </v-flex>
            </v-layout>
            <!--   *****************************FORMULARIO DE REGISTRO DE ASISTENCIA P94  item-value="id_permiso"
                  item-text="valor"****************************** -->
            <v-layout row wrap v-if="id_permi == 94">
              <v-flex xs12 md6 v-if="id_permi == 94 && id_tipo_omision == 2">
                <v-autocomplete
                  :items="permiso_omision"
                  :item-value="
                    val => {
                      return val;
                    }
                  "
                  :item-text="
                    val => {
                      return `${val.tipo_permiso} : ${val.fecha_desde} , ${val.hora_desde} - ${val.hora_hasta}`;
                    }
                  "
                  v-model="permiso.id_permiso_omision"
                  label="Seleccionar permiso (omisión de marcado)"
                  :rules="$validate(['required'])"
                  @input="obtenerHorarioLaboral()"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <v-flex xs12 md6 v-if="id_permi == 94 && id_tipo_omision == 3">
                <v-autocomplete
                  :items="compensacion_omision"
                  :item-value="
                    val => {
                      return val;
                    }
                  "
                  :item-text="
                    val => {
                      return `${val.tipo_permiso} : ${val.fecha_compensacion} , ${val.hora_desde} - ${val.hora_hasta}`;
                    }
                  "
                  v-model="permiso.id_compensacion_omision"
                  label="Seleccionar compensación (omisión de marcado)"
                  :rules="$validate(['required'])"
                  @input="obtenerHorarioLaboral()"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <!-- OMISIONES POR COMISION DE VIAJE -->
              <v-flex xs12 md6 v-if="id_permi == 94 && id_tipo_omision == 4">
                <v-autocomplete
                  :items="compensacion_comisiones_viaje"
                  :item-value="
                    val => {
                      return val;
                    }
                  "
                  :item-text="
                    val => {
                      return `${val.cite} | ${$moment(val.fecha).format(
                        'DD/MM/YYYY'
                      )} | ${val.hora}`;
                    }
                  "
                  v-model="permiso.id_compensacion_omision"
                  label="Seleccionar comisión de viaje (omisión de marcado)"
                  :rules="$validate(['required'])"
                  @input="obtenerHorarioLaboral()"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <v-flex xs12 md6 v-if="id_tipo_omision == 1">
                <v-radio-group
                  v-model="tipo_dia"
                  @change="obtenerHorarioLaboral()"
                >
                  <v-flex>
                    <v-radio label="Mañana" value="1"></v-radio>
                  </v-flex>
                  <v-flex>
                    <v-radio label="Tarde" value="2"></v-radio>
                  </v-flex>
                </v-radio-group>
              </v-flex>
              <v-flex xs12 md6 v-if="id_tipo_omision == 2">
                <v-radio-group
                  v-model="tipo_horario"
                  @change="obtenerHorarioLaboral()"
                >
                  <v-radio label="Salida" value="2"></v-radio>
                  <v-radio label="Retorno" value="1"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs12 md6 v-if="id_tipo_omision == 1">
                <v-radio-group
                  v-model="tipo_horario"
                  @change="obtenerHorarioLaboral()"
                >
                  <v-radio label="Ingreso" value="1"></v-radio>
                  <v-radio label="Salida" value="2"></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex v-if="id_permi == 14">
                <v-radio-group v-model="permiso.rango_horario" row>
                  <v-flex xs4>
                    <v-radio label="Todo el día" :value="0"></v-radio>
                  </v-flex>
                  <v-flex xs4>
                    <v-radio label="Solo mañana" :value="1"></v-radio>
                  </v-flex>
                  <v-flex xs4>
                    <v-radio label="Solo tarde" :value="2"></v-radio>
                  </v-flex>
                </v-radio-group>
              </v-flex>
            </v-layout>

            <v-flex
              v-if="
                id_permi == 89 ||
                  id_permi == 98 ||
                  id_permi == 99 ||
                  id_permi == 100 ||
                  id_permi == 101
              "
            >
              <v-radio-group
                v-model="permiso.rango_horario"
                row
                :rules="$validate(['required'])"
                required
              >
                <v-flex xs4>
                  <v-radio label="Solo mañana" :value="1"></v-radio>
                </v-flex>
                <v-flex xs4>
                  <v-radio label="Solo tarde" :value="2"></v-radio>
                </v-flex>
              </v-radio-group>
            </v-flex>

            <v-layout>
              <v-flex md4 v-if="id_permi == 94">
                <v-text-field
                  type="time"
                  label="Hora"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  disabled
                  v-model="hora_calculada"
                />
              </v-flex>
            </v-layout>
            <v-layout>
              <p v-if="id_permi == 94">
                <strong>Nota.-</strong>
                <strong
                  >Se le recomienda tener mayor cuidado y responsabilidad,
                  debido a que su reincidencia sera sancionada de acuerdo al
                  Reglamento Interno de Personal.</strong
                >
              </p>
            </v-layout>

            <v-layout v-if="false">
              <p v-if="id_permi == 8">
                <strong
                  >Usted cuenta con 25 min. de tolerancia antes y
                  despues</strong
                >
              </p>
            </v-layout>
            <!-- <p v-if="id_permi != 8 || id_permi != 87 || id_permi == 88 || id_permi==24">
              <strong>Total Horas..:</strong>
              {{
                (
                  $moment(
                    this.permisoDetalle.fecha_hasta +
                      " " +
                      this.permisoDetalle.hora_hasta
                  ).diff(
                    this.permisoDetalle.fecha_desde +
                      " " +
                      this.permisoDetalle.hora_desde,
                    "minutes"
                  ) / 60
                ).toFixed(2)
              }}
            </p>
            <p v-if="id_permi == 8 || id_permi == 87">
              <strong>Total Horas:</strong>
              {{
                (
                  $moment(
                  
                      this.permisoDetalle.hora_hasta
                  ).diff(
                   
                      this.permisoDetalle.hora_desde,
                    "minutes"
                  ) / 60
                ).toFixed(2)
              }}
            </p> -->
          </v-container>
        </v-card-text>

        <v-card-actions class="pr-4">
          <v-spacer></v-spacer>
          <v-btn @click.native="close()" color="error">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            :loading="loading"
            :disabled="!valid"
            color="primary"
            @click="save()"
          >
            <v-icon>save</v-icon>
            Registrar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";

export default {
  mixins: [validate],
  props: ["item"],
  mounted() {
    //justificacion
    this.$bus.$on("openDialogModificarPermiso", async item => {
      this.permiso = item;
      //omision
      if (this.permiso.id_tipo_permiso == "94") {
        await this.obtenerPermisosPersonaOmision();
        await this.obtenerComisionesViajeOmision();
        await this.obtenerCompensacionesPersonaOmision();
        if (
          this.permiso.id_permiso_omision ||
          this.permiso.id_permiso_omision != null
        ) {
          //this.id_tipo_omision = 2;
          this.tipo_horario = this.permiso.marcado_omision + "";
        } else {
          this.id_tipo_omision = 1;
        }
      }
      //permiso 102
      if (this.permiso.id_tipo_permiso == 102) {
        if (this.permiso.justificacion) {
          console.log("+++", this.permiso.justificacion);
          this.justificacion = this.permiso.justificacion;
        }
      }
      if (this.permiso.id_tipo_permiso == "96") {
        if (this.permiso.compensa_tolerancia == 1) {
          this.radio_data = 1;
        } else {
          this.radio_data = 0;
        }
      }
      if ([90, 5].includes(parseInt(this.permiso.id_tipo_permiso))) {
        this.permiso.fecha_retorno = this.permiso.fecha_retorno
          .split("/")
          .reverse()
          .join("-");
        await this.obtenerAgenteCapacitacion();
        await this.verificaCenso(this.permiso.id_tipo_permiso);
      }
      if (
        this.permiso.id_tipo_permiso >= 37 &&
        this.permiso.id_tipo_permiso <= 43
      ) {
        if (
          (this.permiso.hora_desde == "08:30" ||
            this.permiso.hora_desde == "08:00") &&
          (this.permiso.hora_hasta == "12:00" ||
            this.permiso.hora_hasta == "12:30")
        ) {
          this.permiso.rango_horario2 = 1;
        } else {
          this.permiso.rango_horario2 = 2;
        }
      }
      // Permiso 18 sin goce de haberes
      if (
        this.permiso.id_tipo_permiso == 44 ||
        this.permiso.id_tipo_permiso == 18
      ) {
        await this.obtenerSubpermiso(this.permiso.id_tipo_permiso);
      }
      this.id_permi = item.id_tipo_permiso;
      this.per_hora_desde = item.hora_desde;
      this.permi_lugar = item.permiso.lugar;
      this.permi_motivo = item.permiso.motivo;
      await this.getPermisoDetalles(item.permiso.id);
      this.permiso.motivo = this.permiso.permiso.motivo;

      if (item.permiso.ruta_archivo) {
        this.ruta_a = item.permiso.ruta_archivo;
      } else {
        this.ruta_a = "";
      }

      this.dias_incapacidad = parseInt(this.permiso.dias_incapacidad);
      this.dialog = true;
      this.permiso.nro_de_dias = parseInt(item.nro_dias) + 1;
      await this.calculaDiasHabiles();
      this.hora_calculada = this.permisoDetalle.hora_desde;
    });
    this.date_formated_fecha_desde = this.$moment(this.date_fecha_desde).format(
      "DD/MM/YYYY"
    );
    this.obtenerTipoPermiso();
    this.obtenerLugarAtencion();
  },
  data() {
    return {
      dias_de_incapacidad: 0,
      per_hora_desde: "",
      tipo_subpermisos: [],
      bandera_calcula_sig_fecha: false,
      errors: {
        denied: false
      },
      justificacion: null,
      errors2: {
        file: false,
        denied: false
      },
      tipos_omision: [
        { id: 1, valor: "OMISIÓN DE MARCADO HORARIO REGULAR" },
        { id: 2, valor: "OMISIÓN DE MARCADO PAPELETA DE PERMISO" },
        //{ id: 3, valor: "OMISIÓN DE COMPENSACIONES" },
        //{ id: 4, valor: "OMISIÓN DE MARCADO COMISIÓN DE VIAJE" }
      ],
      id_tipo_omision: null,
      permiso_omision: [],
      compensacion_omision: [],
      compensacion_comisiones_viaje: [],
      bandera_file: false,
      dias: 0,
      id_permi: "",
      permi_lugar: "",
      permi_motivo: "",
      dias_incapacidad: "",
      ruta_a: "",
      file: "",
      dialog: false,
      edit: true,
      dias_habiles: 0,
      permiso: {
        id_tipo_permiso: null,
        motivo: "",
        permi_fecha_hasta: "",
        permi_fecha_desde: ""
      },
      tipos_baja: [
        { id: 1, descripcion: "PRENATAL" },
        { id: 2, descripcion: "POST NATAL" },
        {
          id: 3,
          descripcion:
            "OTROS(ENFERMEDAD COMUN,RIESGO PROFESIONAL, RIESGO EXTRAORDINARIO)"
        }
      ],
      permisos: [],
      tipo_permisos: [],
      permiso_detalle: {},
      valid: false,
      date_fecha_desde: "",
      date_fecha_hasta: null,
      time_hora_desde: null,
      time_hora_hasta: null,
      loading: false,
      // Variable permiso - Formulario de registro de asistencia
      tipo_horario: null,
      tipo_dia: null,
      hora_calculada: null,

      headers: [
        {
          text: "Fecha salida",
          sortable: false
        },
        {
          text: "Fecha hasta",
          sortable: false
        },
        {
          text: "Hora desde",
          sortable: false
        },
        {
          text: "Hora hasta",
          sortable: false
        },
        {
          text: "Total Horas",
          sortable: false
        },
        {
          text: "Acción",
          sortable: false
        }
      ],
      permiso_detalles: [],
      permisoDetalle: [],
      permiso_detalles_delete: [],
      count_id: 0,
      horas_disponibles: null,
      horas_solicitadas: 0,
      tiempos_radio: {
        "todo-dia": {
          hora_desde: "08:30",
          hora_hasta: "16:30"
        },
        "toda-mañana": {
          hora_desde: "08:30",
          hora_hasta: "12:30"
        },
        "toda-tarde": {
          hora_desde: "12:30",
          hora_hasta: "16:30"
        },
        Mañana: {
          hora_desde: "Mañana"
        },
        Tarde: {
          hora_desde: "Tarde"
        }
      },
      radio_data: "",
      radio_data2: "",
      // Variables permiso censo
      capacitacion_censista: [],
      primer_permiso_censo: null
    };
  },
  watch: {
    date_fecha_desde(val) {
      this.date_fecha_desde = val;
    },
    date_fecha_hasta(val) {
      this.date_fecha_hasta = val;
    },
    date_fecha_solicitud(val) {
      this.date_fecha_solicitud = val;
      this.date_formatted_fecha_solicitud =
        this.$moment(val).format("DD/MM/YYYY") ||
        this.$moment().format("DD/MM/YYYY");
    }
  },
  methods: {
    // Metodo para cargar datos de un permiso censo si existe
    async verificaCenso(id_tipo_permiso) {
      try {
        if (id_tipo_permiso == 5) {
          // Buscamos si existe el permiso inicial
          //
          let res = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_busca_permiso_censo_2024(${this.getPersonaId()})"){
                  respuesta
                }
              }
            `
          });
          let rpta_censo =
            res.runQuery.respuesta[0].fn_busca_permiso_censo_2024;
          rpta_censo = rpta_censo.split("|");
          // Preguntamos si existe el permiso
          if (rpta_censo[0] == "1" && rpta_censo[1]) {
            this.primer_permiso_censo = JSON.parse(rpta_censo[1])[0];
          } else {
            this.primer_permiso_censo = null;
          }
        } else {
          this.primer_permiso_censo = null;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // Metodo para obtener los diferentes tipos de capacitacion censo
    async obtenerAgenteCapacitacion() {
      try {
        let res = await this.$service.graphql({
          query: `
            query{
              params(tipo:"capacitacion_agente"){
                rows{
                  id
                  valor
                  tipo
                }
              }
            }
          `
        });
        this.capacitacion_censista = res.params.rows;
      } catch (error) {
        console.log(error);
      }
    },
    // Obtener horario de entrada o salida, continuo -dicontinuo
    async obtenerHorarioLaboral() {
      //permisoDetalle.fecha_desde
      try {
        if (!this.permisoDetalle.fecha_desde) {
          this.$message.info("Ingrese una fecha");
          return;
        }
        this.hora_calculada = "";
        if (this.id_tipo_omision == 1) {
          if (this.tipo_dia && this.tipo_horario) {
            let id_persona = this.getPersonaId();
            ///permiso 94 formulario de registro de asistenncia
            if (this.permiso.id_tipo_permiso == 94) {
              let respuesta = await this.$service.graphql({
                query: `
                  query{
                    runQuery(consulta:"select control.fn_obtiene_horarios_ingreso_salida_persona(${id_persona},${parseInt(
                  this.tipo_dia
                )},${parseInt(this.tipo_horario)}),'${
                  this.permisoDetalle.fecha_desde
                }'"){
                      respuesta
                    }
                  }
                `
              });
              respuesta =
                respuesta.runQuery.respuesta[0]
                  .fn_obtiene_horarios_ingreso_salida_persona;
              let horarios = respuesta.split("|");
              if (horarios[0] == "1") {
                this.hora_calculada = horarios[1];
              } else {
                this.mensaje_error = horarios[1];
                this.$message.info(this.mensaje_error);
              }
            }
          }
        }
        if (this.id_tipo_omision == 2) {
          if (this.permiso.id_permiso_omision && this.tipo_horario) {
            if (this.permiso.id_tipo_permiso == 94) {
              if (this.tipo_horario == 2) {
                this.hora_calculada = this.permiso.id_permiso_omision.hora_desde;
              }
              if (this.tipo_horario == 1) {
                this.hora_calculada = this.permiso.id_permiso_omision.hora_hasta;
              }
            }
          }
        }
        if (this.id_tipo_omision == 3) {
          if (this.permiso.id_compensacion_omision) {
            if (this.permiso.id_tipo_permiso == 94) {
              this.hora_calculada = this.permiso.id_compensacion_omision.hora_hasta;
            }
          }
        }
        // COmisiones de viaje
        if (this.id_tipo_omision == 4) {
          if (this.permiso.id_compensacion_omision.hora) {
            if (this.permiso.id_tipo_permiso == 94) {
              this.hora_calculada = this.permiso.id_compensacion_omision.hora;
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    //obtener permisos persona, para registrar la omision de marcado
    async obtenerPermisosPersonaOmision() {
      try {
        let id_persona = this.getPersonaId();
        this.permiso_omision = [];
        let res = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta: "select * from control.v_permisos_por_funcionario vppf where vppf.id_persona =${id_persona} and vppf.id_estado in (77,7,21,75) order by vppf.fecha_desde desc"){
                  respuesta
                }
              }
            `
        });
        this.permiso_omision = res.runQuery.respuesta;
      } catch (error) {
        console.log(error);
      }
    },
    //obtener comisiones de viaje, para registrar la omision de marcado
    async obtenerComisionesViajeOmision() {
      try {
        let id_persona = this.getPersonaId();
        this.compensacion_comisiones_viaje = [];
        let res = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta: "select vc.cite ,vc.fecha ,vc.hora from control.v_comision_persona_omision vc where vc.id_persona = ${parseInt(
                  id_persona
                )} order by vc.fecha desc, vc.hora desc"){
                  respuesta
                }
              }
            `
        });
        this.compensacion_comisiones_viaje = res.runQuery.respuesta;
      } catch (error) {
        console.log(error);
      }
    },

    async obtenerCompensacionesPersonaOmision() {
      try {
        let id_persona = this.getPersonaId();
        this.compensacion_omision = [];
        let res = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta: "select tp.descripcion as tipo_permiso, p.numero , pc.id_permiso ,pc.hora_desde ,pc.hora_hasta,pc.fecha_desde fecha_compensacion,p.id_persona ,pd.fecha_desde as fecha_permiso from control.permiso_compensacion pc , control.permiso p,control.tipo_permiso tp ,control.permiso_detalle pd where p.id=pc.id_permiso and tp.id=p.id_tipo_permiso and p.id_persona = ${parseInt(
                  id_persona
                )} and p.id_estado in (77,7) and pd.id_permiso =p.id order by pc.fecha_desde desc"){
                  respuesta
                }
              }
            `
        });
        this.compensacion_omision = res.runQuery.respuesta;
      } catch (error) {
        console.log(error);
      }
    },
    //para permiso trabajo continuo =102
    async calculaHorarioDiscontinuo() {
      try {
        let id_persona;
        let user = this.$storage.get("user");
        if (
          this.$route.params.id == null ||
          this.$route.params.id == undefined
        ) {
          id_persona = user.id_persona;
        } else {
          id_persona = parseInt(this.$route.params.id);
        }
        let respuesta = await this.$service.graphql({
          query: `
                  query{
                          runQuery(consulta:"SELECT control.fn_obtiene_horarios_salida_entrada(${id_persona}, '${this.permisoDetalle.fecha_desde}')"){
                            respuesta
                          }
                        }
                      `
        });
        respuesta =
          respuesta.runQuery.respuesta[0].fn_obtiene_horarios_salida_entrada;
        respuesta = respuesta.split("|");
        if (respuesta[0] == "1") {
          this.hora_hasta_trabajo_continuo = respuesta[1];
          this.hora_desde_trabajo_continuo = respuesta[2];
        } else {
          this.$message.info(respuesta[1]);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerFechaSalidaYEntrada() {
      try {
        let fecha;
        let hora;
        let id_persona = this.permiso.id_persona;
        let bandera = false;

        if (
          this.permiso.id_tipo_permiso == 6 &&
          this.permiso.fecha_nac_muerte &&
          this.permiso.hora_nac_muerte
        ) {
          fecha = this.permiso.fecha_nac_muerte;
          hora = this.permiso.hora_nac_muerte;
          bandera = true;
        }
        if (
          this.permiso.id_tipo_permiso == 61 &&
          this.permiso.fecha_nac_muerte &&
          this.permiso.hora_nac_muerte
        ) {
          fecha = this.permiso.fecha_nac_muerte;
          hora = this.permiso.hora_nac_muerte;
          bandera = true;
        }
        if (
          this.permiso.id_tipo_permiso == 12 &&
          this.permiso.fecha_nac_muerte
        ) {
          fecha = this.permiso.fecha_nac_muerte;

          hora = "00:00";
          bandera = true;
        }

        if (bandera) {
          let respuesta = await this.$service.graphql({
            query: `
                query{
                  runQuery(consulta:"select control.fn_obtiene_fechas_licencia(${parseInt(
                    this.permiso.id_tipo_permiso
                  )},${id_persona},'${fecha}','${hora}')"){
                  respuesta
                  }
                }

              `
          });
          let resp = respuesta.runQuery.respuesta[0].fn_obtiene_fechas_licencia;
          resp = resp.split("|");

          this.permisoDetalle.fecha_desde = resp[0];
          this.permisoDetalle.fecha_hasta = resp[1];
        }
      } catch (error) {
        console.log(error);
      }
    },
    //verifica que una vacacion aprobada no choque con el permiso:
    async verificaVacaciones(fecha_desde, fecha_hasta) {
      let existe_vacacion = false;
      let permisos_consulta = "";
      let respuesta;
      try {
        respuesta = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta:"select vacaciones.fn_verifica_coincidencia_de_vacaciones_aprobadas(${this.getPersonaId()},'${fecha_desde}','${fecha_hasta}')"){
                  respuesta
                }
              }
            `
        });
        respuesta =
          respuesta.runQuery.respuesta[0]
            .fn_verifica_coincidencia_de_vacaciones_aprobadas;

        if (respuesta != "0") {
          existe_vacacion = true;
          permisos_consulta +=
            "<br><strong>Usted tiene la siguiente vacación aprobada en las fechas solicitadas:</strong><br>" +
            respuesta.replace(/#/g, "<br>");
          this.$message.warning(permisos_consulta);
        }
        return existe_vacacion;
      } catch (error) {
        console.log(error);
      }
    },
    //VALIDADOR DE FECHAS:
    validarFechasFinales() {
      let validacion_fechas;
      //validando fechas:

      let bandera_fechas = true;
      let tipo_permiso = parseInt(this.id_permi);
      switch (tipo_permiso) {
        case 61: //LICENCIA POR PATERNIDAD
          validacion_fechas = this.validarFechas(
            this.permiso.fecha_nac_muerte,
            2
          );
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 6: //LICENCIA POR DUELO
          validacion_fechas = this.validarFechas(
            this.permiso.fecha_nac_muerte,
            2
          );
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 12: //LICENCIA POR MATRIMONIO
          validacion_fechas = this.validarFechas(
            this.permiso.fecha_nac_muerte,
            2
          );
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 102: //TRABAJO CONTINUO
          validacion_fechas = this.validarFechas(
            this.permisoDetalle.fecha_desde,
            2
          );
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 101: //ASUETO
          validacion_fechas = this.validarFechas(
            this.permisoDetalle.fecha_desde,
            2
          );
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 100: //ASUETO DIA DE LA MUJER
          validacion_fechas = this.validarFechas(
            this.permisoDetalle.fecha_desde,
            2
          );
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 99: //ASUETO DIA DE LA MADRE
          validacion_fechas = this.validarFechas(
            this.permisoDetalle.fecha_desde,
            2
          );
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 98: //ASUETO DIA DEL PADRE
          validacion_fechas = this.validarFechas(
            this.permisoDetalle.fecha_desde,
            2
          );
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 96: //TOLERANCIA
          validacion_fechas = this.validarFechas(
            this.permisoDetalle.fecha_desde,
            2
          );
          console.log("hfhfhf", this.form.fecha_desde);
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;

        case 89: //ASUETO POR CUMPLEAÑOS
          validacion_fechas = this.validarFechas(
            this.permisoDetalle.fecha_desde,
            2
          );
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 88: //PERMISO PERSONAL CON GOCE DE HABERES
          validacion_fechas = this.validarFechas(
            this.permisoDetalle.fecha_desde,
            2
          );
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 87: //PERMISO OFICIAL POR HORAS
          validacion_fechas = this.validarFechas(
            this.permisoDetalle.fecha_desde,
            2
          );
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 103: //comision servicio
          validacion_fechas = this.validarFechas(
            this.permisoDetalle.fecha_desde,
            2
          );
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 38: // TOLERANCIA MAMOGRAFIA (798-252)
          validacion_fechas = this.validarFechas(
            this.permisoDetalle.fecha_desde,
            2
          );
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 41: // TOLERANCIA EXÁMENES COMPLEMENTARIOS (798-252)
          validacion_fechas = this.validarFechas(
            this.permisoDetalle.fecha_desde,
            2
          );
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 42: // TOLERANCIA EXÁMEN FÍSICO DE PRÓSTATA (798-252)
          validacion_fechas = this.validarFechas(
            this.permisoDetalle.fecha_desde,
            2
          );
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 43: // TOLERANCIA EXÁMEN DE LABORATORIO (PSA)(798-252)
          validacion_fechas = this.validarFechas(
            this.permisoDetalle.fecha_desde,
            2
          );
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 37: // TOLERANCIA MAMA Y PAPANICOLAOU (798-252)
          validacion_fechas = this.validarFechas(
            this.permisoDetalle.fecha_desde,
            2
          );
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 40: // TOLERANCIA COLON (ANAMNESIS Y EXÁMEN FÍSICO 798-252)
          validacion_fechas = this.validarFechas(
            this.permisoDetalle.fecha_desde,
            2
          );
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 8: // JUSTIFICATIVO CAJA
          validacion_fechas = this.validarFechas(
            this.permisoDetalle.fecha_desde,
            2
          );
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;

        case 90: // BAJA MÉDICA
          validacion_fechas = this.validarFechas(
            this.permisoDetalle.fecha_desde,
            2
          );
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        case 5: // CENSO
          validacion_fechas = this.validarFechas(
            this.permisoDetalle.fecha_desde,
            2
          );
          if (validacion_fechas == false) {
            bandera_fechas = false;
          }
          break;
        default:
          console.log(`Fecha no valida`);
      }
      return bandera_fechas;
    },
    validarFechas(fecha, valor) {
      try {
        //VALOR=1 VALIDAR FECHAS DE LA INTERFAZ -<2999
        //   VALOR=2 VALIDAR FECHAS PARA GUARDAR >2023 && <2999
        let bandera_fechas = true;
        if (fecha) {
          if (fecha.length > 10) {
            this.$message.info("Año no valido");
            bandera_fechas = false;
            return bandera_fechas;
          }
          let año = parseInt(fecha.substring(0, 4));
          //VALOR ==1
          if (valor == 1 && año > 2022) {
            if (año < 2022 || año > 2999) {
              this.$message.info("Año no valido");
              return;
            }
          }
          //VALOR ==2
          if (valor == 2 && año > 2022) {
            if (año > 2999) {
              this.$message.info("Año no valido");
              bandera_fechas = false;
              return bandera_fechas;
            }
          }
          if (valor == 2 && año < 2023) {
            this.$message.info("Año no valido");
            bandera_fechas = false;
            return bandera_fechas;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async calculaDiasHabiles() {
      // SELECT "control".fn_obtiene_dias_habiles(p_fecha_desde date, p_fecha_hasta date)
      let dias = 0;
      let respuesta;
      if (this.permisoDetalle.fecha_desde && this.permisoDetalle.fecha_hasta) {
        try {
          respuesta = await this.$service.graphql({
            query: `
                  query{
                    runQuery(consulta:"select control.fn_obtiene_dias_habiles('${this.permisoDetalle.fecha_desde}','${this.permisoDetalle.fecha_hasta}')"){
                      respuesta
                    }
                  }
                `
          });
          dias = respuesta.runQuery.respuesta[0].fn_obtiene_dias_habiles;
        } catch (error) {
          console.log(error);
        }
      }
      this.dias_habiles = dias;
    },
    async obtenerSubpermiso(id_subpermi) {
      try {
        if (this.permiso.id_tipo_permiso == id_subpermi) {
          /*  let res = await this.$service.graphql({
            query: `

              query{
                tipoSubpermisos(id_permiso:${parseInt(this.permiso.id_tipo_permiso)}){
                  rows{
                    id
                    id_estado
                    id_permiso
                    descripcion
                  }
                }
              }
          `,
          });
          this.tipo_subpermisos = res.tipoSubpermisos.rows;*/
          this.tipo_subpermisos = [
            { id: 1, descripcion: "Cáncer infantil o adolescente" },
            {
              id: 3,
              descripcion:
                "Enfermedades neurológicas que requieren de tratamiento quirúrgico"
            },
            {
              id: 2,
              descripcion: "Enfermedades sistémicas que requieren trasplante"
            },
            { id: 4, descripcion: "Insuficiencia renal crónica" },
            {
              id: 5,
              descripcion:
                "Enfermedades osteoarticulares (huesos y articulaciones) que requieren tratamiento quirúrgico y rehabilitación"
            },
            { id: 6, descripcion: "Discapacidad grave y muy grave" },
            {
              id: 7,
              descripcion:
                "Accidente grave con riesgo de muerte o secuela funcional severa y permanente"
            },
            { id: 8, descripcion: "Accidente grave" }
          ];
        }
        if (id_subpermi == 18) {
          let consulta = `SELECT * FROM CONTROL.v_subtipo_permiso WHERE id_tipo_permiso = 18`;
          let respuesta = await this.$service.graphql({
            query: `
                query{
                  runQuery(consulta:"${consulta}"){
                  respuesta
                  }
                  }
                `
          });
          this.tipo_subpermisos = respuesta.runQuery.respuesta;
        }
      } catch (error) {
        console.log(error);
      }
    },
    activarBandera() {
      this.bandera_calcula_sig_fecha = true;
    },
    desactivarBandera() {
      if (this.id_permi == 90) {
        this.bandera_calcula_sig_fecha = false;
      }
    },
    async obtenerTipoPermiso() {
      try {
        let res = await this.$service.graphql({
          query: `
            query {
							tipoPermisos(id_estado: 19) {
                rows {
                  id
                  descripcion
                  refrigerio
                  tiempo_maximo
                  tiempo_minimo
                  estado {
                    descripcion
                    abrev
                  }
                }
              }
            }
          `
        });
        this.tipo_permisos = res.tipoPermisos.rows;
      } catch (error) {
        console.log(error);
      }
    },
    allowedStep: m => m % 5 === 0,

    async eliminarArchivo() {
      this.$refs.file.value = "";
      this.file = "";
      this.permiso.permiso.ruta_archivo = "";
      this.ruta_a = "";
      this.bandera_file = true;
    },

    async obtenerSiguienteFecha() {
      try {
        //almacenar en campo motivo el que se adiciono de tipo de baja
        let respuesta;
        let dias_de_incapacidad = parseInt(this.permiso.nro_dias);
        let fecha = this.permisoDetalle.fecha_desde;
        if (this.permiso.nro_dias && this.permisoDetalle.fecha_desde) {
          var query = ``;
          var tipo_funcion;
          // Preguntamos si es baja medica o censo
          if (this.permiso.id_tipo_permiso == 90) {
            query = `select control.fn_suma_dias_fecha('${dias_de_incapacidad}','${fecha}')`;
            tipo_funcion = "fn_suma_dias_fecha";
          } else if (this.permiso.id_tipo_permiso == 5) {
            // Restamos 1 dia para obtener la fecha correcta
            dias_de_incapacidad--;
            tipo_funcion = "fn_sgte_fecha_habil_funcionario";
            query = `select general.fn_sgte_fecha_habil_funcionario('${fecha}',${dias_de_incapacidad},${this.getPersonaId()})`;
          }
          this.bandera_calcula_sig_fecha = true;
          respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"${query}"){
                  respuesta
                }
              }
            `
          });
          respuesta = respuesta.runQuery.respuesta[0][tipo_funcion];
          this.permiso.fecha_retorno = respuesta
            .split("/")
            .reverse()
            .join("-");
          return this.permiso.fecha_retorno;
        }
      } catch (error) {
        console.log(error);
      }
    },
    handleFileUpload2() {
      if (this.$refs.file.value !== "") {
        const file = this.$refs.file.files[0];

        if (this.$refs.file.value === "") {
          this.errors2.file = true;
        } else {
          this.errors2.file = false;
        }
        if (this.$refs.file.files[0].type.includes("application/pdf")) {
          this.errors2.denied = false;
        } else {
          this.errors2.denied = true;
        }
        this.file = file;
      }
    },
    handleFileUpload() {
      if (this.$refs.file.value !== "") {
        const file2 = this.$refs.file.files[0];
        if (this.$refs.file.files[0].type.includes("application/pdf")) {
          this.errors.denied = false;
        } else {
          this.errors.denied = true;
        }

        this.bandera_file = false;
        this.file = file2;
      }
    },
    /*limpiarFile(){
		this.bandera_file=true
		this.file =""

	},*/
    async obtenerLugarAtencion() {
      try {
        let res = await this.$service.graphql({
          query: `
            query{
            vLugarAtencions{
              rows{
                        id
                        lugar
                        tolerancia_minutos
                  }
                            }

                  }
          `
        });
        this.lugar_atencion = res.vLugarAtencions.rows;
      } catch (error) {
        console.log(error);
      }
    },

    asignarFechaHasta(fecha) {
      this.permisoDetalle.fecha_hasta = fecha;
    },
    async getPermisoDetalles(id_permiso) {
      if (this.id_permi == 94 && this.permi_motivo == "Mañana") {
        this.radio_data2 = this.permi_motivo;
      }
      if (this.id_permi == 94 && this.permi_motivo == "Tarde") {
        this.radio_data2 = this.permi_motivo;
      }
      if (this.id_permi == 94) {
        let response = await this.$service.graphql({
          query: `
                query{
                  permisoDetalles(id_permiso:${id_permiso}){
                    rows{
                      id
                      id_permiso
                      fecha_desde
                      fecha_hasta
                      hora_desde
                      hora_hasta
                    }
                  }
                }
        		`
        });
        if (response) {
          this.permisoDetalle = response.permisoDetalles.rows[0];
        }
      } else {
        let response = await this.$service.graphql({
          query: `
                query{
                  permisoDetalles(id_permiso:${id_permiso}){
                    rows{
                      id
                      id_permiso
                      fecha_desde
                      fecha_hasta
                      hora_desde
                      hora_hasta
                    }
                  }
                }
        		`
        });
        if (response) {
          this.permisoDetalle = response.permisoDetalles.rows[0];
          if (this.id_permi == 14) {
            this.setRadioButton(
              this.permisoDetalle.hora_desde,
              this.permisoDetalle.hora_hasta
            );
          }
          if (this.id_permi == 89) {
            this.setRadioButton(
              this.permisoDetalle.hora_desde,
              this.permisoDetalle.hora_hasta
            );
          }
        }
      }
    },
    validarPermiso() {
      const user = this.$storage.get("user");
      this.$service
        .graphql({
          query: `
          query {
						controlPermisoValidate(id_persona: ${user.id_persona}, fecha_solicitud: "${this.date_fecha_desde}", id_tipo_permiso: ${this.permiso.id_tipo_permiso}){
							horas
						}
				}
        `
        })
        .then(response => {
          if (response) {
            this.horas_disponibles = response.controlPermisoValidate.horas;
            this.horas_disponibles += this.horas_solicitadas;
            this.edit = false;
          }
        });
    },
    close() {
      this.dialog = false;
      this.errors = {
        file: false,
        denied: false
      };
      this.permiso = {
        id_tipo_permiso: null,
        motivo: ""
      };
      this.file = "";
      this.bandera_file = false;
      this.date_fecha_desde = null;
      this.date_fecha_hasta = null;
      this.time_hora_desde = null;
      this.time_hora_hasta = null;
      this.permiso_detalles = [];
      this.count_id = 0;
      this.horas_disponibles = null;
      this.horas_solicitadas = 0;
      this.edit = true;
      this.permiso_detalles_delete = [];
      (this.tipo_horario = null),
        (this.tipo_dia = null),
        (this.hora_calculada = null),
        this.$bus.$emit("closeDialogModificarPermiso");
    },

    LimpiaCad(str) {
      let st = str;
      if (str != null) {
        st = st.replaceAll("\\", "\\\\");
        st = st.replaceAll('"', '\\"');
        st = st.replaceAll("'", "");
      } else {
        st = "";
      }
      return st;
    },
    getPersonaId() {
      const user = this.$storage.get("user");
      //const menu = this.$storage.get("menu");
      return this.$route.params.id ? this.$route.params.id : user.id_persona;
    },
    async verificarPermisosRango(
      fecha_desde,
      fecha_hasta,
      hora_desde,
      hora_hasta,
      id_permiso
    ) {
      //Funcion notifica que hay un permiso creado en el rango de fechas seleccionado
      // control.fn_muestra_permisos_funcionario(p_id_persona integer, p_fecha date)
      let existePermisos = false;
      let permisos = "¿Esta seguro guardar el permiso?";
      let permisos_consulta = "";
      let respuesta;

      try {
        respuesta = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta:"select control.fn_permisos_por_funcionario_actualiza(${this.getPersonaId()},'${fecha_desde}','${fecha_hasta}','${hora_desde}','${hora_hasta}',${parseInt(
            id_permiso
          )})"){
                  respuesta
                }
              }
            `
        });
        respuesta =
          respuesta.runQuery.respuesta[0].fn_permisos_por_funcionario_actualiza;
        respuesta = respuesta.split("|");
        console.log(respuesta);
        if (respuesta[0] == "1") {
          existePermisos = true;
          permisos_consulta +=
            "<br><strong>Usted tiene los siguientes permisos en las fechas u horarios solicitados:</strong><br>" +
            respuesta[1].replace(/#/g, "<br>");
        }
      } catch (error) {
        console.log(error);
      }
      console.log(permisos);
      if (existePermisos) {
        this.$alert("No puede crear el permiso" + permisos_consulta);
      }
      return [existePermisos, permisos + permisos_consulta];
    },
    async obtenerHorarioPersona(id_persona, id_radio_data, fecha) {
      try {
        let respuesta = await this.$service.graphql({
          query: `
            query{
              runQuery(consulta:"select control.fn_rango_horario_por_persona_solo_horarios(${parseInt(
                id_persona
              )},${parseInt(id_radio_data)},'${fecha}')"){
                respuesta
              }
            }
          `
        });
        if (
          respuesta.runQuery.respuesta[0]
            .fn_rango_horario_por_persona_solo_horarios != null
        ) {
          respuesta = respuesta.runQuery.respuesta[0].fn_rango_horario_por_persona_solo_horarios.split(
            "|"
          );
          if (respuesta[0] != "0") {
            return [respuesta[0], respuesta[1]];
          } else {
            return -1;
          }
        } else {
          this.$message.warning(
            "Sin horario asignado para la fecha del permiso"
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
    async save() {
      if (this.validarFechasFinales() == false) {
        return;
      }
      let resps;
      let respuesta;
      let ruta_ar = "";
      let correcto;
      correcto = true;
      resps = [];
      // Archivos no obligatorios
      if (
        (this.id_permi == 87 || this.id_permi == 96) &&
        ((this.ruta_a == "" && this.file) || (this.ruta_a != "" && this.file))
      ) {
        if (this.errors.denied) {
          return this.errors;
        }
      }
      // Archivos obligatorios

      if (
        this.id_permi == 8 ||
        this.id_permi == 12 ||
        this.id_permi == 6 ||
        this.id_permi == 61 ||
        this.id_permi == 18 ||
        this.id_permi == 90 ||
        this.id_permi == 5 ||
        this.id_permi == 95 ||
        this.id_permi == 103 ||

        (this.id_permi >= 37 && this.id_permi <= 44)
      ) {
        if (this.$refs.file.value === "") {
          if (this.ruta_a == "" || !this.ruta_a) {
            this.errors2.file = true;

            return this.errors2;
          }
        } else {
          this.errors2.file = false;
        }

        if (this.errors2.denied) {
          return this.errors2;
        }
      }
      //Cargar ruta del archivo
      if (
        (this.id_permi == 12 ||
          this.id_permi == 8 ||
          this.id_permi == 87 ||
          this.id_permi == 95 ||
          this.id_permi == 6 ||
          this.id_permi == 61 ||
          this.id_permi == 18 ||
          this.id_permi == 103 ||
          this.id_permi == 90 ||
          this.id_permi == 5 ||
          this.id_permi == 96 ||
          (this.id_permi >= 37 && this.id_permi <= 44)) &&
        ((this.ruta_a == "" && this.file) || (this.ruta_a != "" && this.file))
      ) {
        if (this.$refs.file.value !== "") {
          let formData = new FormData();
          formData.append("file", this.file);
          let res = await this.$http.post(
            process.env.API_URL + "public/upload",
            formData
          );
          ruta_ar = res.data;
        }
      } else {
        if (this.permiso.permiso.ruta_archivo != "") {
          ruta_ar = this.permiso.permiso.ruta_archivo;
        } else {
          ruta_ar = "";
        }
      }

      if (!this.form) {
        let user = this.$storage.get("user");
        let id_persona = user.id_persona;
        let id = user.id;
        let mi_id = user.id_persona;
        let valor_tiempo;
        //let ruta_archivo=this.form.ruta_archivo;
        let fechita = this.$moment(new Date()).format("YYYY/MM/DD");

        let permisocab = {
          id_permiso: parseInt(this.permiso.id_permiso),
          motivo: this.LimpiaCad(this.permi_motivo),
          fecha_permiso: fechita,
          lugar: this.LimpiaCad(this.permi_lugar),
          id_pers: parseInt(id_persona),
          id_funcionario: parseInt(id),
          ruta_archivo: ruta_ar,
          id_tipo_permiso: parseInt(this.permiso.id_tipo_permiso),
          fecha_desde: this.permiso.fecha_desde
        };
        let fecha2 = this.$moment(this.permisoDetalle.fecha_desde).format(
          "DD/MM/YYYY"
        );
        let fecha3 = this.$moment(this.permisoDetalle.fecha_hasta).format(
          "DD/MM/YYYY"
        );

        if (this.id_permi == 6) {
          permisocab.fecha_permiso = this.$moment(
            permisocab.fecha_permiso
          ).format("DD/MM/YYYY");
        }
        if (this.id_permi >= 37 && this.id_permi <= 43) {
          fecha2 = this.permisoDetalle.fecha_desde;
          fecha3 = this.permisoDetalle.fecha_desde;
          if (this.permiso.rango_horario2 == 1) {
            valor_tiempo = 1;
          } else {
            valor_tiempo = 2;
          }
        }
        if (this.id_permi == 8) {
          fecha2 = this.permisoDetalle.fecha_desde;
          fecha3 = this.permisoDetalle.fecha_desde;
        }
        if (this.id_permi == 61 || this.id_permi == 12) {
          fecha2 = this.permisoDetalle.fecha_desde;
          fecha3 = this.permisoDetalle.fecha_hasta;
        }

        if (this.id_permi == 90) {
          fecha2 = this.permisoDetalle.fecha_desde;
          fecha3 = this.permiso.fecha_retorno;
        }
        if (this.id_permi == 87 || this.id_permi == 88 || this.id_permi == 14) {
          this.permisoDetalle.fecha_hasta = this.permisoDetalle.fecha_desde;
        }
        if (this.id_permi == 94) {
          fecha2 = this.permisoDetalle.fecha_desde;
          fecha3 = this.permisoDetalle.fecha_desde;

          this.permisoDetalle.hora_desde = this.hora_calculada;
          this.permisoDetalle.hora_hasta = this.hora_calculada;
        }

        if (this.id_permi == 95) {
          this.permisoDetalle.hora_desde = "";
          this.permisoDetalle.hora_hasta = "";
        }
        let permisodet = {
          id_permiso_detalle: parseInt(this.permisoDetalle.id),
          fecha_desde: fecha2,
          fecha_hasta: fecha3,
          hora_desde: this.permisoDetalle.hora_desde,
          hora_hasta: this.permisoDetalle.hora_hasta,
          id_funcionario: id
        };
        if (this.id_permi == 44) {
          //consulta si existe una vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            permisodet.fecha_desde,
            permisodet.fecha_hasta
          );
          if (verifica_vacacion == true) {
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            permisodet.fecha_desde,
            permisodet.fecha_hasta,
            "",
            "",
            permisocab.id_permiso
          );
          if (consulta[0] == true) {
            return;
          }
          this.$confirm(consulta[1], async () => {
            try {
              respuesta = await this.$service.graphql({
                query: `
                          query{
                            runQuery(consulta:"select control.fn_actualiza_ds3462 (${
                              permisocab.id_permiso
                            },'${permisocab.fecha_permiso}',${
                  user.id_persona
                },'${permisodet.fecha_desde}','${permisodet.fecha_hasta}','${
                  permisocab.ruta_archivo
                }',${parseInt(this.permiso.id_tipo_subpermiso)})"){
                                  respuesta
                              }
                            }
                          `
              });
              let respuesta2 =
                respuesta.runQuery.respuesta[0].fn_actualiza_ds3462;
              resps = respuesta2.split("|");
              correcto = resps[0];
              if (correcto === "1") {
                this.$confirm("Modificación exitosa", () => {
                  this.close();
                });
              } else {
                this.$confirm(resps[1], () => {});
              }
            } catch (error) {
              console.log(error);
            }
          });
        }
        //102
        if (this.id_permi == 102) {
          //consulta si existe una vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            this.permisoDetalle.fecha_desde,
            this.permisoDetalle.fecha_desde
          );
          if (verifica_vacacion == true) {
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            this.permisoDetalle.fecha_desde,
            this.permisoDetalle.fecha_desde,
            this.permisoDetalle.hora_desde,
            this.permisoDetalle.hora_hasta,
            permisocab.id_permiso
          );
          if (consulta[0] == true) {
            return;
          }
          this.$confirm(consulta[1], async () => {
            try {
              respuesta = await this.$service.graphql({
                query: `
                  query{
                    runQuery(consulta:"select control.fn_actualiza_permiso_trabajo_continuo(${permisocab.id_permiso},'${this.permisoDetalle.fecha_desde}','${this.permisoDetalle.hora_desde}','${this.permisoDetalle.hora_hasta}','${this.justificacion}',${user.id},${this.permiso.rol})"){
                      respuesta
                    }
                  }
                `
              });
              let respuesta2 =
                respuesta.runQuery.respuesta[0]
                  .fn_actualiza_permiso_trabajo_continuo;
              resps = respuesta2.split("|");
              correcto = resps[0];
              if (correcto === "1") {
                this.$confirm("Modificación exitosa", () => {
                  this.close();
                });
              } else {
                this.$confirm(resps[1], () => {});
              }
            } catch (error) {
              console.log(error);
            }
          });
        }
        //comision de servicios
        if (this.id_permi == 103) {
          //consulta si existe una vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            this.permisoDetalle.fecha_desde,
            this.permisoDetalle.fecha_hasta
          );
          if (verifica_vacacion == true) {
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            this.permisoDetalle.fecha_desde,
            this.permisoDetalle.fecha_hasta,
            this.permisoDetalle.hora_desde,
            this.permisoDetalle.hora_hasta,
            permisocab.id_permiso
          );
          if (consulta[0] == true) {
            return;
          }
          this.$confirm(consulta[1], async () => {
            try {
              permisocab.motivo = permisocab.motivo.replace(
                /(\r\n|\n|\r)/gm,
                " "
              );
              permisocab.motivo = permisocab.motivo.replace(/"/g, "`");

              respuesta = await this.$service.graphql({
                query: `
                          query{
                            runQuery(consulta:"select control.fn_actualiza_comision_servicio(${
                              permisocab.id_permiso
                            },${parseInt(this.permiso.id_persona)},'${
                  permisocab.motivo
                }','${this.permisoDetalle.fecha_desde}','${
                  this.permisoDetalle.fecha_hasta
                }','${permisocab.lugar}','${this.permisoDetalle.hora_desde}','${
                  this.permisoDetalle.hora_hasta
                }','${permisocab.ruta_archivo}',${user.id},4)"){
                                  respuesta
                              }
                            }
                          `
              });
              let respuesta2 =
                respuesta.runQuery.respuesta[0].fn_actualiza_comision_servicio;
              resps = respuesta2.split("|");
              correcto = resps[0];
              if (correcto === "1") {
                this.$confirm("Modificación exitosa", () => {
                  this.close();
                });
              } else {
                this.$confirm(resps[1], () => {});
              }
            } catch (error) {
              console.log(error);
            }
          });
        }


        if (this.id_permi == 105) {

          console.log('guardar 105');
          //consulta si existe una vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            this.permisoDetalle.fecha_desde,
            this.permisoDetalle.fecha_hasta
          );
          if (verifica_vacacion == true) {
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            this.permisoDetalle.fecha_desde,
            this.permisoDetalle.fecha_hasta,
            this.permisoDetalle.hora_desde,
            this.permisoDetalle.hora_hasta,
            permisocab.id_permiso
          );
          if (consulta[0] == true) {
            return;
          }
          this.$confirm(consulta[1], async () => {
            try {
              permisocab.motivo = permisocab.motivo.replace(
                /(\r\n|\n|\r)/gm,
                " "
              );
              permisocab.motivo = permisocab.motivo.replace(/"/g, "`");

              respuesta = await this.$service.graphql({
                query: `
                          query{
                            runQuery(consulta:"select control.fn_actualiza_comision_servicio(${
                              permisocab.id_permiso
                            },${parseInt(this.permiso.id_persona)},'${
                  permisocab.motivo
                }','${this.permisoDetalle.fecha_desde}','${
                  this.permisoDetalle.fecha_hasta
                }','${permisocab.lugar}','${this.permisoDetalle.hora_desde}','${
                  this.permisoDetalle.hora_hasta
                }','${permisocab.ruta_archivo}',${user.id},4)"){
                                  respuesta
                              }
                            }
                          `
              });
              let respuesta2 =
                respuesta.runQuery.respuesta[0].fn_actualiza_comision_servicio;
              resps = respuesta2.split("|");
              correcto = resps[0];
              if (correcto === "1") {
                this.$confirm("Modificación exitosa", () => {
                  this.close();
                });
              } else {
                this.$confirm(resps[1], () => {});
              }
            } catch (error) {
              console.log(error);
            }
          });
        }

        ////
        if (this.id_permi >= 37 && this.id_permi <= 43) {
          // Validando si existe otros permisos en el mismo rango de fechas y horas
          let hora_desde, hora_hasta;
          if (valor_tiempo) {
            hora_desde = "";
            hora_hasta = "";
            [hora_desde, hora_hasta] = await this.obtenerHorarioPersona(
              this.getPersonaId(),
              valor_tiempo,
              permisocab.fecha_permiso
            );
          }
          //consulta si existe una vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            permisodet.fecha_desde,
            permisodet.fecha_desde
          );
          if (verifica_vacacion == true) {
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            permisodet.fecha_desde,
            permisodet.fecha_desde,
            hora_desde,
            hora_hasta,
            permisocab.id_permiso
          );
          if (consulta[0] == true) {
            return;
          }
          this.$confirm(consulta[1], async () => {
            try {
              respuesta = await this.$service.graphql({
                query: `
                  query{
                    runQuery(consulta:"select control.fn_actualiza_pap_pros (${permisocab.id_permiso},'${permisocab.fecha_permiso}',${user.id_persona},'${permisodet.fecha_desde}','${valor_tiempo}','${permisocab.ruta_archivo}',${this.permiso.rol})"){
                      respuesta
                    }
                  }
                `
              });

              this.ruta_a = "";
              respuesta = respuesta.runQuery.respuesta[0].fn_actualiza_pap_pros;
              resps = respuesta.split("|");
              correcto = resps[0];

              if (correcto == "1") {
                this.$confirm("Modificación exitosa", () => {
                  this.close();
                });
              } else {
                if (
                  resps.length == 3 &&
                  resps[2] == "Fecha Inicio Menor a Fecha Permiso"
                ) {
                  this.$confirm(resps[2], () => {});
                } else {
                  this.$confirm(resps[1], () => {});
                }
              }
            } catch (error) {
              console.log(error);
            }
          });
        }
        if (this.id_permi == 87) {

          permisodet.fecha_desde = this.$moment(this.permisoDetalle.fecha_desde).format(
          "DD/MM/YYYY"
        );
        permisodet.fecha_hasta = this.$moment( this.permisoDetalle.fecha_hasta).format(
          "DD/MM/YYYY"
        );

          //consulta si existe una vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
    
            this.permisoDetalle.fecha_desde,
            this.permisoDetalle.fecha_hasta
          );
          if (verifica_vacacion == true) {
            return;
          }
 
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            this.permisoDetalle.fecha_desde,
            this.permisoDetalle.fecha_hasta,
            this.permisoDetalle.hora_desde,
            this.permisoDetalle.hora_hasta,
            permisocab.id_permiso
           
  
          );
          if (consulta[0] == true) {
            return;
          }
          this.$confirm(consulta[1], async () => {
            try {
              permisocab.motivo = permisocab.motivo.replace(
                /(\r\n|\n|\r)/gm,
                " "
              );
//////
        /*
          permisocab.fecha_permiso = this.$moment(permisocab.fecha_permiso).format(
          "DD/MM/YYYY"
        );
        */
       
       
              console.log('permisodet.fecha_desde1111',permisodet.fecha_desde);
              console.log('permisodet.fecha_hasta111',permisodet.fecha_hasta);
        ///////
              permisocab.motivo = permisocab.motivo.replace(/"/g, "`");
              respuesta = await this.$service.graphql({
                query: `
                    query{
                      runQuery(consulta:"select control.fn_actualiza_permiso_archivo(${permisocab.id_permiso},'${permisocab.motivo}','${permisocab.fecha_permiso}','${permisocab.lugar}',${mi_id},'${this.permisoDetalle.fecha_desde}','${this.permisoDetalle.fecha_hasta}','${permisodet.hora_desde}','${permisodet.hora_hasta}','${permisocab.ruta_archivo}',${this.permiso.rol})"){
                        respuesta
                      }
                    }
                  `
              });
              this.ruta_a = "";
              respuesta =
                respuesta.runQuery.respuesta[0].fn_actualiza_permiso_archivo;
              resps = respuesta.split("|");
              correcto = resps[0];
              if (correcto == "1") {
                //"Modificación exitosa"
                this.$confirm("Modificación exitosa", () => {
                  this.close();
                });
              } else {
                // this.$message.error(resps[1])
                if (
                  resps.length == 3 &&
                  resps[2] == "Fecha Inicio Menor a Fecha Permiso"
                ) {
                  // this.$message.error(resps[2])
                  this.$confirm(resps[2], () => {});
                } else {
                  //this.$message.error(resps[1])
                  this.$confirm(resps[1], () => {});
                }
              }
            } catch (error) {
              console.log(error);
            }
          });
        }
        if (this.id_permi == 88) {
          //consulta si existe una vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            permisodet.fecha_desde,
            permisodet.fecha_hasta
          );
          if (verifica_vacacion == true) {
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            permisodet.fecha_desde,
            permisodet.fecha_hasta,
            permisodet.hora_desde,
            permisodet.hora_hasta,
            permisocab.id_permiso
          );
          if (consulta[0] == true) {
            return;
          }
          this.$confirm(consulta[1], async () => {
            try {
              permisocab.motivo = permisocab.motivo.replace(
                /(\r\n|\n|\r)/gm,
                " "
              );
              permisocab.motivo = permisocab.motivo.replace(/"/g, "`");
              respuesta = await this.$service.graphql({
                query: `
                    query{
                      runQuery(consulta:"select control.fn_actualiza_permiso_particular(${permisocab.id_permiso},'${permisocab.motivo}','${permisocab.fecha_permiso}','${permisocab.lugar}',${mi_id},'${permisodet.fecha_desde}','${permisodet.fecha_hasta}','${permisodet.hora_desde}','${permisodet.hora_hasta}',${this.permiso.rol})"){
                            respuesta
                        }
                      }
                    `
              });
              let respuesta2 =
                respuesta.runQuery.respuesta[0].fn_actualiza_permiso_particular;
              resps = respuesta2.split("|");
              correcto = resps[0];

              if (correcto == "1") {
                //"Modificación exitosa"
                this.$confirm("Modificación exitosa", () => {
                  this.close();
                });
              } else {
                this.$confirm(resps[1], () => {});
              }
            } catch (error) {
              console.log(error);
            }
          });
        }
        // Asuetos p100 p99 p98 p89 p98
        if (
          this.id_permi == 89 ||
          this.id_permi == 98 ||
          this.id_permi == 99 ||
          this.id_permi == 100
        ) {
          // Validando si existe otros permisos en el mismo rango de fechas y horas
          let hora_desde, hora_hasta;
          console.log("++++", valor_tiempo);
          if (this.permiso.rango_horario) {
            hora_desde = "";
            hora_hasta = "";
            [hora_desde, hora_hasta] = await this.obtenerHorarioPersona(
              this.getPersonaId(),
              this.permiso.rango_horario,
              this.permisoDetalle.fecha_desde
            );
          }
          //consulta si existe una vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            this.permisoDetalle.fecha_desde,
            this.permisoDetalle.fecha_desde
          );
          if (verifica_vacacion == true) {
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            this.permisoDetalle.fecha_desde,
            this.permisoDetalle.fecha_desde,
            hora_desde,
            hora_hasta,
            this.permiso.id_permiso
          );
          if (consulta[0] == true) {
            return;
          }
          this.$confirm(consulta[1], async () => {
            // control.fn_actualiza_permiso_asueto(
            //   p_id_permiso integer,
            //   p_fecha_actual date,
            //   p_fecha_asueto date,
            //   p_tipo_permiso integer,
            //   p_id_funcionario integer,
            //   p_id_persona integer,
            //   p_bandera integer
            //   )
            let fecha_actual = new Date();
            let fecha_actual_formato = this.$moment(fecha_actual).format(
              "DD/MM/YYYY"
            );
            try {
              respuesta = await this.$service.graphql({
                query: `
                  query{
                    runQuery(consulta:"select control.fn_actualiza_permiso_asueto(${
                      this.permiso.id_permiso
                    },'${fecha_actual_formato}','${
                  this.permisoDetalle.fecha_desde
                }',${this.permiso.id_tipo_permiso},${user.id},${
                  this.permiso.id_persona
                },${this.permiso.rango_horario},${parseInt(
                  this.permiso.rol
                )})"){
                      respuesta
                      }
                    }
                  `
              });
              let respuesta2 =
                respuesta.runQuery.respuesta[0].fn_actualiza_permiso_asueto;
              resps = respuesta2.split("|");
              correcto = resps[0];

              if (correcto == "1") {
                this.$confirm("Modificación exitosa", () => {
                  this.close();
                });
              } else {
                this.$confirm(resps[1], () => {});
              }
            } catch (error) {
              console.log(error);
            }
          });
        }
        if (this.id_permi == 101) {
          // Validando si existe otros permisos en el mismo rango de fechas y horas
          let hora_desde, hora_hasta;
          if (valor_tiempo) {
            hora_desde = "";
            hora_hasta = "";
            [hora_desde, hora_hasta] = await this.obtenerHorarioPersona(
              this.getPersonaId(),
              this.permiso.rango_horario,
              this.permisoDetalle.fecha_desde
            );
          }
          //consulta si existe una vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            this.permisoDetalle.fecha_desde,
            this.permisoDetalle.fecha_desde
          );
          if (verifica_vacacion == true) {
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            this.permisoDetalle.fecha_desde,
            this.permisoDetalle.fecha_desde,
            hora_desde,
            hora_hasta,
            this.permiso.id_permiso
          );
          if (consulta[0] == true) {
            return;
          }
          this.$confirm(consulta[1], async () => {
            let fecha_actual = new Date();
            let fecha_actual_formato = this.$moment(fecha_actual).format(
              "DD/MM/YYYY"
            );
            try {
              respuesta = await this.$service.graphql({
                query: `
                  query{
                    runQuery(consulta:"select control.fn_actualiza_permiso_asueto_otros(${this.permiso.id_permiso},'${fecha_actual_formato}','${this.permisoDetalle.fecha_desde}',${this.permiso.id_tipo_permiso},${user.id},${this.permiso.id_persona},${this.permiso.rango_horario},'${this.permi_motivo}')"){
                      respuesta
                      }
                    }
                  `
              });
              let respuesta2 =
                respuesta.runQuery.respuesta[0]
                  .fn_actualiza_permiso_asueto_otros;
              resps = respuesta2.split("|");
              correcto = resps[0];
              if (correcto == "1") {
                this.$confirm("Modificación exitosa", () => {
                  this.close();
                });
              } else {
                this.$confirm(resps[1], () => {});
              }
            } catch (error) {
              console.log(error);
            }
          });
        }
        if (this.id_permi == 96) {
          //consulta si existe una vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            permisodet.fecha_desde,
            permisodet.fecha_hasta
          );
          if (verifica_vacacion == true) {
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            permisodet.fecha_desde,
            permisodet.fecha_hasta,
            permisodet.hora_desde,
            permisodet.hora_hasta,
            permisocab.id_permiso
          );
          if (consulta[0] == true) {
            return;
          }
          this.$confirm(consulta[1], async () => {
            try {
              permisocab.motivo = permisocab.motivo.replace(
                /(\r\n|\n|\r)/gm,
                " "
              );
              permisocab.motivo = permisocab.motivo.replace(/"/g, "`");
              respuesta = await this.$service.graphql({
                query: `
                                                  query{
                                                    runQuery(consulta:"select control.fn_actualiza_tolerancia(${
                                                      permisocab.id_permiso
                                                    },'${
                  permisocab.fecha_permiso
                }',${permisocab.id_funcionario},'${permisodet.fecha_desde}','${
                  permisodet.fecha_hasta
                }','${permisodet.hora_desde}','${permisodet.hora_hasta}','${
                  permisocab.motivo
                }',${parseInt(this.radio_data)},${parseInt(
                  this.permiso.rol
                )})"){
                                                      respuesta
                                                    }
                                                  }
                                                `
              });
              //

              this.bandera_file = false;

              respuesta =
                respuesta.runQuery.respuesta[0].fn_actualiza_tolerancia;
              resps = respuesta.split("|");
              correcto = resps[0] == 1;
              if (correcto == "1") {
                //"Modificación exitosa"
                this.$confirm("Modificación exitosa", () => {
                  this.close();
                });
              } else {
                if (resps[2] == "Fecha Inicio Menor a Fecha Permiso") {
                  resps[1] = resps[2];
                }
                this.$confirm(resps[1], () => {});
              }
            } catch (error) {
              console.log(error);
            }
          });
        }
        // Permiso CENSO
        if (this.id_permi == 5) {
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            permisodet.fecha_desde,
            permisodet.fecha_hasta,
            "",
            "",
            permisocab.id_permiso
          );
          if (consulta[0] == true) {
            return;
          }
          this.$confirm(consulta[1], async () => {
            try {
              const query = `select control.fn_registra_actualiza_permiso_censo_2024(${
                permisocab.id_permiso
              },${this.getPersonaId()},'${permisodet.fecha_desde}',${
                this.permiso.nro_dias
              },${this.permiso.id_parametro_permiso},'${
                permisocab.ruta_archivo
              }',${permisocab.id_funcionario},${parseInt(this.permiso.rol)})`;
              respuesta = await this.$service.graphql({
                query: `
                  query{
                    runQuery(consulta:"${query}"){
                          respuesta
                      }
                  }
                `
              });
              this.bandera_file = false;
              respuesta =
                respuesta.runQuery.respuesta[0]
                  .fn_registra_actualiza_permiso_censo_2024;
              resps = respuesta.split("|");
              correcto = resps[0];
              if (correcto == "1") {
                this.$alert("Modificación exitosa", () => {
                  this.close();
                });
              } else {
                this.$alert(resps[1], () => {});
              }
            } catch (error) {
              console.log(error);
            }
          });
        }
        if (this.id_permi == 90) {
          //consulta si existe una vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            permisodet.fecha_desde,
            permisodet.fecha_hasta
          );
          if (verifica_vacacion == true) {
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            permisodet.fecha_desde,
            permisodet.fecha_hasta,
            "",
            "",
            permisocab.id_permiso
          );
          if (consulta[0] == true) {
            return;
          }
          this.$confirm(consulta[1], async () => {
            try {
              permisocab.motivo = permisocab.motivo.replace(
                /(\r\n|\n|\r)/gm,
                " "
              );
              permisocab.motivo = permisocab.motivo.replace(/"/g, "`");
              respuesta = await this.$service.graphql({
                query: `
                query{
                      runQuery(consulta:"select control.fn_actualiza_permiso_baja_medica(${
                        permisocab.id_permiso
                      },'${permisocab.motivo}','${permisocab.fecha_permiso}',${
                  user.id
                },'${permisodet.fecha_desde}','${permisodet.fecha_hasta}','${
                  permisocab.ruta_archivo
                }',${parseInt(this.permiso.rol)})"){
                        respuesta
                      }
                  }
                `
              });
              this.bandera_file = false;
              respuesta =
                respuesta.runQuery.respuesta[0]
                  .fn_actualiza_permiso_baja_medica;
              resps = respuesta.split("|");
              correcto = resps[0];
              if (correcto == "1") {
                this.$confirm("Modificación exitosa", () => {
                  this.close();
                });
              } else {
                this.$confirm(resps[1], () => {});
              }
            } catch (error) {
              console.log(error);
            }
          });
        }
        if (this.id_permi == 6) {
          //consulta si existe una vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            permisodet.fecha_desde,
            permisodet.fecha_hasta
          );
          if (verifica_vacacion == true) {
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            permisodet.fecha_desde,
            permisodet.fecha_hasta,
            "",
            "",
            permisocab.id_permiso
          );
          if (consulta[0] == true) {
            return;
          }
          this.$confirm(consulta[1], async () => {
            try {
              respuesta = await this.$service.graphql({
                query: `
                  query{
                      runQuery(consulta:"select control.fn_actualiza_duelo(${
                        permisocab.id_permiso
                      },'${permisocab.fecha_permiso}',${user.id},'${
                  permisodet.fecha_desde
                }','${permisodet.fecha_hasta}','${
                  this.permiso.fecha_nac_muerte
                }','${this.permiso.hora_nac_muerte}','${
                  permisocab.ruta_archivo
                }',${this.permiso.id_persona},${parseInt(this.permiso.rol)})"){
                        respuesta
                      }
                  }
                  `
              });
              this.bandera_file = false;
              respuesta = respuesta.runQuery.respuesta[0].fn_actualiza_duelo;
              resps = respuesta.split("|");
              correcto = resps[0];
              if (correcto == "1") {
                this.$confirm("Modificación exitosa", () => {
                  this.close();
                });
              } else {
                this.$confirm(resps[1], () => {});
              }
            } catch (error) {
              console.log(error);
            }
          });
        }
        if (this.id_permi == 61) {
          //consulta si existe una vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            permisodet.fecha_desde,
            permisodet.fecha_hasta
          );
          if (verifica_vacacion == true) {
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            permisodet.fecha_desde,
            permisodet.fecha_hasta,
            "",
            "",
            permisocab.id_permiso
          );
          if (consulta[0] == true) {
            return;
          }
          this.$confirm(consulta[1], async () => {
            try {
              respuesta = await this.$service.graphql({
                query: `
                  query{
                    runQuery(consulta:"select control.fn_actualiza_paternidad(${
                      permisocab.id_permiso
                    },'${permisocab.fecha_permiso}',${user.id},'${
                  permisodet.fecha_desde
                }','${permisodet.fecha_hasta}','${
                  this.permiso.fecha_nac_muerte
                }','${this.permiso.hora_nac_muerte}','${
                  permisocab.ruta_archivo
                }',${this.permiso.id_persona},${parseInt(this.permiso.rol)})"){
                      respuesta
                    }
                  }
                `
              });
              this.bandera_file = false;
              respuesta =
                respuesta.runQuery.respuesta[0].fn_actualiza_paternidad;
              resps = respuesta.split("|");
              correcto = resps[0];
              if (correcto == "1") {
                this.$confirm("Modificación exitosa", () => {
                  this.close();
                });
              } else {
                this.$confirm(resps[1], () => {});
              }
            } catch (error) {
              console.log(error);
            }
          });
        }

        if (this.id_permi == 12) {
          //consulta si existe una vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            permisodet.fecha_desde,
            permisodet.fecha_hasta
          );
          if (verifica_vacacion == true) {
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            permisodet.fecha_desde,
            permisodet.fecha_hasta,
            "",
            "",
            permisocab.id_permiso
          );
          if (consulta[0] == true) {
            return;
          }
          this.$confirm(consulta[1], async () => {
            try {
              respuesta = await this.$service.graphql({
                query: `
                  query{
                    runQuery(consulta:"select control.fn_actualiza_permiso_matrimonio(${
                      this.id_permi
                    },${permisocab.id_permiso},${permisocab.id_pers},'${
                  this.permiso.fecha_nac_muerte
                }','${permisodet.fecha_desde}','${permisodet.fecha_hasta}',${
                  permisocab.id_funcionario
                },'${permisocab.ruta_archivo}',${parseInt(this.permiso.rol)})"){
                      respuesta
                    }
                  }
                `
              });

              respuesta =
                respuesta.runQuery.respuesta[0].fn_actualiza_permiso_matrimonio;
              let resps = respuesta.split("|");
              let correcto = resps[0];
              if (correcto == "1") {
                this.$confirm("Modificación exitosa", () => {
                  this.close();
                });
              } else {
                this.$confirm(resps[1], () => {});
              }
            } catch (error) {
              console.log(error);
            }
          });
        }
        if (this.id_permi == 94) {
          let res;
          try {
            let id_permiso_omision = null;
            if (this.id_tipo_omision == 1) {
              id_permiso_omision = null;
              this.tipo_horario = null;
            }
            if (this.id_tipo_omision == 2) {
              id_permiso_omision = parseInt(
                this.permiso.id_permiso_omision.id_permiso
              );
              this.tipo_horario = parseInt(this.tipo_horario);
            }
            if (this.id_tipo_omision == 3) {
              id_permiso_omision = parseInt(
                this.permiso.id_compensacion_omision.id_permiso
              );
              this.tipo_horario = parseInt(this.tipo_horario);
            }
            // permisocab.motivo = permisocab.motivo.replace(
            //   /(\r\n|\n|\r)/gm,
            //   " "
            // );
            // permisocab.motivo = permisocab.motivo.replace(/"/g, "`");
            let id_persona_func=this.getPersonaId();
            
            res = await this.$service.graphql({
              query: `
                    query{
                      runQuery(consulta:"select control.fn_actualiza_formulario_asistencia(${
                        permisocab.id_permiso
                      },'',${id_persona_func},'${
                permisocab.fecha_permiso
              }','',${permisocab.id_funcionario},'${permisodet.fecha_desde}','${
                permisodet.fecha_hasta
              }','${permisodet.hora_desde}','${permisodet.hora_hasta}','${
                permisocab.ruta_archivo
              }',${parseInt(this.permiso.rol)},${id_permiso_omision},${
                this.tipo_horario
              })"){
                        respuesta
                      }
                    }
                  `
            });
            respuesta =
              res.runQuery.respuesta[0].fn_actualiza_formulario_asistencia;
            resps = respuesta.split("|");

            correcto = resps[0] == 1;
            if (correcto == "1") {
              this.$confirm("Modificación exitosa", () => {
                this.close();
              });
            } else {
              this.$confirm(resps[1], () => {});
            }
          } catch (error) {
            console.log(error);
          }
          // });
        }
        if (this.id_permi == 8) {
          //consulta si existe una vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            permisodet.fecha_desde,
            permisodet.fecha_desde
          );
          if (verifica_vacacion == true) {
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            permisodet.fecha_desde,
            permisodet.fecha_desde,
            permisodet.hora_desde,
            permisodet.hora_hasta,
            permisocab.id_permiso
          );
          if (consulta[0] == true) {
            return;
          }
          this.$confirm(consulta[1], async () => {
            try {
              respuesta = await this.$service.graphql({
                query: `
                    query{
                      runQuery(consulta:"select control.fn_actualiza_justifica_caja(${
                        permisocab.id_permiso
                      },'${permisocab.fecha_permiso}',${
                  permisocab.id_funcionario
                },'${permisodet.fecha_desde}','${permisodet.fecha_desde}','${
                  permisodet.hora_desde
                }','${permisodet.hora_hasta}','1','${
                  permisocab.ruta_archivo
                }',${parseInt(this.permiso.rol)})"){
                        respuesta
                      }
                    }
                  `
              });

              respuesta =
                respuesta.runQuery.respuesta[0].fn_actualiza_justifica_caja;
              //resps = respuesta.split("|");
              let resps = respuesta.split("|");
              let correcto = resps[0];

              if (correcto == "1") {
                this.$confirm("Modificación exitosa", () => {
                  this.close();
                });
              } else {
                this.$confirm(resps[1], () => {});
              }
            } catch (error) {
              console.log(error);
            }
          });
        }
        if (this.id_permi == 14) {
          // Validando si existe otros permisos en el mismo rango de fechas y horas
          let hora_desde, hora_hasta;
          if (
            this.permiso.rango_horario == 0 ||
            this.permiso.rango_horario == 1 ||
            this.permiso.rango_horario == 2
          ) {
            hora_desde = "";
            hora_hasta = "";
            [hora_desde, hora_hasta] = await this.obtenerHorarioPersona(
              this.getPersonaId(),
              this.permiso.rango_horario,
              permisodet.fecha_desde
            );
          }
          //consulta si existe una vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            permisodet.fecha_desde,
            permisodet.fecha_desde
          );
          if (verifica_vacacion == true) {
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            permisodet.fecha_desde,
            permisodet.fecha_desde,
            hora_desde,
            hora_hasta,
            permisocab.id_permiso
          );
          if (consulta[0] == true) {
            return;
          }
          this.$confirm(consulta[1], async () => {
            try {
              respuesta = await this.$service.graphql({
                query: `
                  query{
                    runQuery(consulta:"select control.fn_actualiza_lic_personal(${
                      permisocab.id_permiso
                    },${permisocab.id_funcionario},'${
                  permisodet.fecha_desde
                }','${permisodet.fecha_desde}',${
                  this.permiso.rango_horario
                },${parseInt(this.permiso.rol)})"){
                      respuesta
                    }
                  }
                `
              });

              respuesta =
                respuesta.runQuery.respuesta[0].fn_actualiza_lic_personal;
              let resps = respuesta.split("|");
              let correcto = resps[0];
              if (correcto == "1") {
                //"Modificación exitosa"
                this.$confirm("Modificación exitosa", () => {
                  this.close();
                });
              } else {
                this.$confirm(resps[1], () => {});
              }
            } catch (error) {
              console.log(error);
            }
          });
        }
        if (this.id_permi == 95) {
          //consulta si existe una vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            permisodet.fecha_desde,
            permisodet.fecha_hasta
          );
          if (verifica_vacacion == true) {
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            permisodet.fecha_desde,
            permisodet.fecha_hasta,
            permisodet.hora_desde,
            permisodet.hora_hasta,
            permisocab.id_permiso
          );
          if (consulta[0] == true) {
            return;
          }
          // permisocab.motivo = permisocab.motivo.replace(/(\r\n|\n|\r)/gm, " ");
          // permisocab.motivo = permisocab.motivo.replace(/"/g, "`");
          this.$confirm(consulta[1], async () => {
            try {
              respuesta = await this.$service.graphql({
                query: `
                  query{
                    runQuery(consulta:"select control.fn_actualiza_permiso_teletrabajo(${permisocab.id_permiso},'','${permisocab.fecha_permiso}','${permisocab.lugar}',${mi_id},'${permisodet.fecha_desde}','${permisodet.fecha_hasta}','${permisodet.hora_desde}','${permisodet.hora_hasta}','${permisocab.ruta_archivo}')"){
                      respuesta
                    }
                  }
                `
              });

              this.ruta_a = "";
              respuesta =
                respuesta.runQuery.respuesta[0]
                  .fn_actualiza_permiso_teletrabajo;
              resps = respuesta.split("|");
              correcto = resps[0];
              if (correcto == "1") {
                //"Modificación exitosa"
                this.$confirm("Modificación exitosa", () => {
                  this.close();
                });
              } else {
                if (
                  resps.length == 3 &&
                  resps[2] == "Fecha Inicio Menor a Fecha Permiso"
                ) {
                  this.$confirm(resps[2], () => {});
                } else {
                  this.$confirm(resps[1], () => {});
                }
              }
            } catch (error) {
              console.log(error);
            }
          });
        }
        // PErmiso sin goce de haberes p18
        if (this.id_permi == 18) {
          //consulta si existe una vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            permisodet.fecha_desde,
            permisodet.fecha_hasta
          );
          if (verifica_vacacion == true) {
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            permisodet.fecha_desde,
            permisodet.fecha_hasta,
            "",
            "",
            this.permiso.id_permiso
          );
          if (consulta[0] == true) {
            return;
          }
          this.$confirm(consulta[1], async () => {
            let permiso_sin_goce = {
              id_permiso: parseInt(this.permiso.id_permiso),
              id_tipo_permiso: parseInt(this.permiso.id_tipo_permiso),
              causal: this.permiso.motivo,
              id_persona: parseInt(this.permiso.id_persona),
              fecha_permiso: this.permiso.permiso.fecha_permiso,
              fecha_desde: permisodet.fecha_desde,
              fecha_hasta: permisodet.fecha_hasta
            };
            let consulta = `SELECT control.fn_actualiza_permiso_sin_haber(${permiso_sin_goce.id_permiso},${permiso_sin_goce.id_tipo_permiso},'${permiso_sin_goce.causal}',${permiso_sin_goce.id_persona},'${permiso_sin_goce.fecha_permiso}','${permiso_sin_goce.fecha_desde}','${permiso_sin_goce.fecha_hasta}',${permisocab.id_funcionario},'${permisocab.ruta_archivo}')`;
            try {
              respuesta = await this.$service.graphql({
                query: `
                      query{
                        runQuery(consulta:"${consulta}"){
                        respuesta
                        }
                        }
                      `
              });
            } catch (error) {
              console.log(error);
            }
            try {
              respuesta =
                respuesta.runQuery.respuesta[0].fn_actualiza_permiso_sin_haber;
              let resps = respuesta.split("|");
              let correcto = resps[0];
              if (correcto === "1") {
                this.$confirm("Modificación exitosa.", () => {
                  this.close();
                });
              } else {
                this.$confirm(resps[1], () => {});
              }
            } catch (error) {
              console.log(error);
            }
          });
        }
      } //cierra !this.form
    },
    setRadioButton(hora_desde, hora_hasta) {
      for (const i in this.tiempos_radio) {
        if (
          hora_desde == this.tiempos_radio[i].hora_desde &&
          hora_hasta == this.tiempos_radio[i].hora_hasta
        ) {
          this.radio_data = i;
          this.tiempos_radio[i].hora_desde;
          break;
        }
      }
    }
  },

  registerPermisoDetalle(id) {
    this.permiso_detalles_delete.forEach(async item => {
      await this.$service
        .graphql({
          query: `
						mutation remove($id: ID!) {
							permisoDetalleDelete(id: $id) {
								deleted
							}
						}
					`,
          variables: { id: item }
        })
        .then(response => {});
    });
    this.permiso_detalles.forEach(async item => {
      item.id_permiso = id;
      item.id_estado = 17;
      delete item.id;
      delete item.delete;
      await this.$service
        .graphql({
          query: `
						mutation add($permisoDetalle: NewPermisoDetalle!) {
							permisoDetalleAdd(permisoDetalle: $permisoDetalle) {
								id
							}
						}
					`,
          variables: {
            permisoDetalle: item
          }
        })
        .then(responsePermisoDetalle => {
          console.log("Ok");
        });
    });
  }
};
</script>

<style>
.archivo_vacio {
  background-color: #55aafaea;
  color: #fff;
  cursor: pointer;
  font-size: 1em;
  font-weight: bold;
  margin: 0 auto 0;
  overflow: hidden;
  padding: 0.5em;
  position: relative;
  text-align: center;
  width: 15em;
}
.archivo_cargado {
  background-color: #6ace61;
  color: #fff;
  cursor: pointer;
  font-size: 1em;
  font-weight: bold;
  margin: 0 auto 0;
  overflow: hidden;
  padding: 0.5em;
  position: relative;
  text-align: center;
  width: 15em;
}
.archivo_vacio .input-file {
  cursor: pointer;
  font-size: 10000px;
  margin: 0;
  opacity: 0;
  outline: 0 none;
  padding: 0;
  position: absolute;
  right: -1000px;
  top: -1000px;
}
.archivo_cargado .input-file {
  cursor: pointer;
  font-size: 10000px;
  margin: 0;
  opacity: 0;
  outline: 0 none;
  padding: 0;
  position: absolute;
  right: -1000px;
  top: -1000px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/permiso/dialogs/ModificarPermiso.vue